/*
 * A highly customizable rating widget that supports images, utf8 glyphs and other html elements!
 * https://github.com/auxiliary/rater
 */
;(function ($, window){
  $.fn.textWidth = function()
  {
    var html_calc = $('<span>' + $(this).html() + '</span>');
    html_calc.css('font-size',$(this).css('font-size')).hide();
    html_calc.prependTo('body');
    var width = html_calc.width();
    html_calc.remove();

    if (width == 0)
    {
      var total = 0;
      $(this).eq(0).children().each(function(){
        total += $(this).textWidth();
      });
      return total;
    }
    return width;
  };

  $.fn.textHeight = function()
  {
    var html_calc = $('<span>' + $(this).html() + '</span>');
    html_calc.css('font-size',$(this).css('font-size')).hide();
    html_calc.prependTo('body');
    var height = html_calc.height();
    html_calc.remove();
    return height;
  };

  /*
   * IE8 doesn't support isArray!
   */
  Array.isArray = function (obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };

  /*
   * Utf-32 isn't supported by default, so we have to use Utf-8 surrogates
   */
  String.prototype.getCodePointLength = function() {
    return this.length-this.split(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g).length+1;
  };

  String.fromCodePoint= function() {
    var chars= Array.prototype.slice.call(arguments);
    for (var i= chars.length; i-->0;) {
      var n = chars[i]-0x10000;
      if (n>=0)
        chars.splice(i, 1, 0xD800+(n>>10), 0xDC00+(n&0x3FF));
    }
    return String.fromCharCode.apply(null, chars);
  };

  /*
   * Starting the plugin itself
   */
  $.fn.rate = function(options)
  {
    if (options === undefined || typeof options === 'object')
    {
      return this.each(function(){
        if (!$.data(this, "rate"))
        {
          $.data(this, "rate", new Rate(this, options));
        }
      });
    }
    else if (typeof options === 'string')
    {
      var args = arguments;
      var returns;
      this.each(function(){
        var instance = $.data(this, "rate");
        if (instance instanceof Rate && typeof instance[options] === 'function')
        {
          returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }
        if (options === 'destroy')
        {
          // Unbind all events and empty the plugin data from instance
          $(instance.element).off();
          $.data(this, 'rate', null);
        }
      });

      return returns !== undefined ? returns : this;
    }
  };

  function Rate(element, options)
  {
    this.element = element;
    this.settings = $.extend({}, $.fn.rate.settings, options);
    this.set_faces = {}; // value, symbol pairs
    this.build();
  }

  Rate.prototype.build = function()
  {
    this.layers = {};
    this.value = 0;
    this.raise_select_layer = false;

    if (this.settings.initial_value)
    {
      this.value = this.settings.initial_value;
    }
    if ($(this.element).attr("data-rate-value"))
    {
      this.value = $(this.element).attr("data-rate-value");
    }

    /*
     * Calculate the selected width based on the initial value
     */
    var selected_width = this.value / this.settings.max_value * 100;

    /*
     * Let's support single strings as symbols as well as objects
     */
    if (typeof this.settings.symbols[this.settings.selected_symbol_type] === 'string')
    {
      var symbol = this.settings.symbols[this.settings.selected_symbol_type];
      this.settings.symbols[this.settings.selected_symbol_type] = {};
      this.settings.symbols[this.settings.selected_symbol_type]['base'] = symbol;
      this.settings.symbols[this.settings.selected_symbol_type]['selected'] = symbol;
      this.settings.symbols[this.settings.selected_symbol_type]['hover'] = symbol;
    }

    /*
     * Making the three main layers (base, select, hover)
     */
    var base_layer = this.addLayer("base-layer", 100, this.settings.symbols[
        this.settings.selected_symbol_type]["base"], true);

    var select_layer = this.addLayer("select-layer", selected_width,
        this.settings.symbols[this.settings.selected_symbol_type]["selected"], true);

    var hover_layer = this.addLayer("hover-layer", 0, this.settings.symbols[
        this.settings.selected_symbol_type]["hover"], false);

    /* var face_layer = this.addLayer("face-layer", 1, this.settings
        .symbols[this.settings.face_layer_symbol_type][0], true); */

    this.layers["base_layer"] = base_layer;
    this.layers["select_layer"] = select_layer;
    this.layers["hover_layer"] = hover_layer;

    /*
     * Bind the container to some events
     */
    $(this.element).on("mousemove", $.proxy(this.hover, this));
    $(this.element).on("click", $.proxy(this.select, this));
    $(this.element).on("mouseleave", $.proxy(this.mouseout, this));

    /*
     * Set the main element as unselectable
     */
    $(this.element).css({
      "-webkit-touch-callout": "none",
      "-webkit-user-select": "none",
      "-khtml-user-select": "none",
      "-moz-user-select": "none",
      "-ms-user-select": "none",
      "user-select": "none",
    });

    /*
     * Update custom input field if provided
     */
    if (this.settings.hasOwnProperty("update_input_field_name"))
    {
      this.settings.update_input_field_name.val(this.value);
    }
  }

  /*
   * Function to add a layer
   */
  Rate.prototype.addLayer = function(layer_name, visible_width, symbol, visible)
  {
    var layer_body = "<div>";
    for (var i = 0; i < this.settings.max_value; i++)
    {
      if (Array.isArray(symbol))
      {
        if (this.settings.convert_to_utf8)
        {
          symbol[i] = String.fromCodePoint(symbol[i]);
        }
        layer_body += "<span>" + (symbol[i]) + "</span>";
      }
      else
      {
        if (this.settings.convert_to_utf8)
        {
          symbol = String.fromCodePoint(symbol);
        }
        layer_body += "<span>" + symbol + "</span>";
      }
    }
    layer_body += "</div>";
    var layer = $(layer_body).addClass("rate-" + layer_name).appendTo(this.element);

    $(layer).css({
      width: visible_width + "%",
      height: $(layer).children().eq(0).textHeight(),
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      display: visible ? 'block' : 'none',
      'white-space': 'nowrap'
    });
    $(this.element).css({
      width: $(layer).textWidth() + "px",
      height: $(layer).height(),
      position: 'relative',
      cursor: this.settings.cursor,
    });

    return layer;
  }

  Rate.prototype.updateServer = function()
  {
    if (this.settings.url != undefined)
    {
      $.ajax({
        url: this.settings.url,
        type: this.settings.ajax_method,
        data: $.extend({}, { value: this.getValue() }, this.settings.additional_data),
        success: $.proxy(function(data){
          $(this.element).trigger("updateSuccess", [data]);
        }, this),
        error: $.proxy(function(jxhr, msg, err){
          $(this.element).trigger("updateError", [jxhr, msg, err]);
        }, this)
      });
    }
  }

  Rate.prototype.getValue = function()
  {
    return this.value;
  }

  Rate.prototype.hover = function(ev)
  {
    var pad = parseInt($(this.element).css("padding-left").replace("px", ""));
    var x = ev.pageX - $(this.element).offset().left - pad;
    var val = this.toValue(x, true);

    if (val != this.value)
    {
      this.raise_select_layer = false;
    }

    if (!this.raise_select_layer && !this.settings.readonly)
    {
      var visible_width = this.toWidth(val);
      this.layers.select_layer.css({display: 'none'});
      if (!this.settings.only_select_one_symbol)
      {
        this.layers.hover_layer.css({
          width: visible_width + "%",
          display: 'block'
        });
      }
      else
      {
        var index_value = Math.floor(val);
        this.layers.hover_layer.css({
          width: "100%",
          display: 'block'
        });
        this.layers.hover_layer.children("span").css({
          visibility: 'hidden',
        });
        this.layers.hover_layer.children("span").eq(index_value != 0 ? index_value - 1 : 0).css({
          visibility: 'visible',
        });
      }
    }
  }

  /*
   * Event for when a rating has been selected (clicked)
   */
  Rate.prototype.select = function(ev)
  {
    if (!this.settings.readonly)
    {
      var old_value = this.getValue();
      var pad = parseInt($(this.element).css("padding-left").replace("px", ""));
      var x = ev.pageX - $(this.element).offset().left - pad;
      var selected_width = this.toWidth(this.toValue(x, true));
      this.setValue(this.toValue(selected_width));
      this.raise_select_layer = true;
    }
  }

  Rate.prototype.mouseout = function()
  {
    this.layers.hover_layer.css({display: 'none'});
    this.layers.select_layer.css({display: 'block'});
  }

  /*
   * Takes a width (px) and returns the value it resembles
   */
  Rate.prototype.toWidth = function(val)
  {
    return val / this.settings.max_value * 100;
  }

  /*
   * Takes a value and calculates the width of the selected/hovered layer
   */
  Rate.prototype.toValue = function(width, in_pixels)
  {
    var val;
    if (in_pixels)
    {
      val = width / this.layers.base_layer.textWidth() * this.settings.max_value;
    }
    else
    {
      val = width / 100 * this.settings.max_value;
    }

    // Make sure the division doesn't cause some small numbers added by
    // comparing to a small arbitrary number.
    var temp = val / this.settings.step_size;
    if (temp - Math.floor(temp) < 0.00005)
    {
      val = Math.round(val / this.settings.step_size) * this.settings.step_size;
    }
    val = (Math.ceil(val / this.settings.step_size)) * this.settings.step_size;
    val = val > this.settings.max_value ? this.settings.max_value : val;
    return val;
  }

  Rate.prototype.getElement = function(layer_name, index)
  {
    return $(this.element).find(".rate-" + layer_name + " span").eq(index - 1);
  }

  Rate.prototype.getLayers = function()
  {
    return this.layers;
  }

  Rate.prototype.setFace = function(value, face)
  {
    this.set_faces[value] = face;
  }

  Rate.prototype.setAdditionalData = function(data)
  {
    this.settings.additional_data = data;
  }

  Rate.prototype.getAdditionalData = function()
  {
    return this.settings.additional_data;
  }

  Rate.prototype.removeFace = function(value)
  {
    delete this.set_faces[value];
  }

  Rate.prototype.setValue = function(value)
  {
    if (!this.settings.readonly)
    {
      if (value < 0)
      {
        value = 0;
      }
      else if (value > this.settings.max_value)
      {
        value = this.settings.max_value;
      }

      var old_value = this.getValue();
      this.value = value;

      /*
       * About to change event, should support prevention later
       */
      var change_event = $(this.element).trigger("change", {
        "from": old_value,
        "to": this.value
      });

      /*
       * Set/Reset faces
       */
      $(this.element).find(".rate-face").remove();
      $(this.element).find("span").css({
        visibility: 'visible'
      });
      var index_value = Math.ceil(this.value);
      if (this.set_faces.hasOwnProperty(index_value))
      {
        var face = "<div>" + this.set_faces[index_value] + "</div>";
        var base_layer_element = this.getElement('base-layer', index_value);
        var select_layer_element = this.getElement('select-layer', index_value);
        var hover_layer_element = this.getElement('hover-layer', index_value);

        var left_pos = base_layer_element.textWidth() * (index_value - 1)
            + (base_layer_element.textWidth() - $(face).textWidth()) / 2;

        $(face).appendTo(this.element).css({
          display: 'inline-block',
          position: 'absolute',
          left: left_pos,
        }).addClass("rate-face");

        base_layer_element.css({
          visibility: 'hidden'
        });
        select_layer_element.css({
          visibility: 'hidden'
        });
        hover_layer_element.css({
          visibility: 'hidden'
        });
      }

      /*
       * Set styles based on width and value
       */
      if (!this.settings.only_select_one_symbol)
      {
        var width = this.toWidth(this.value);
        this.layers.select_layer.css({
          display: 'block',
          width: width + "%",
          height: this.layers.base_layer.css("height")
        });
        this.layers.hover_layer.css({
          display: 'none',
          height: this.layers.base_layer.css("height")
        });
      }
      else
      {
        var width = this.toWidth(this.settings.max_value);
        this.layers.select_layer.css({
          display: 'block',
          width: width + "%",
          height: this.layers.base_layer.css("height")
        });
        this.layers.hover_layer.css({
          display: 'none',
          height: this.layers.base_layer.css("height")
        });
        this.layers.select_layer.children("span").css({
          visibility: 'hidden',
        });
        this.layers.select_layer.children("span").eq(index_value != 0 ? index_value - 1 : 0).css({
          visibility: 'visible',
        });
      }

      // Update the data-rate-value attribute
      $(this.element).attr("data-rate-value", this.value);

      // _reviews.htmldeki v-modeli "newReview.rate" olan gizli inputun valuesu değiştiriliyor.
      // Daha sonra dispatch ile v-modelin tuttuğu değerin de değişmesi sağlanıyor.
      // newReview bir object oldugundan içine rate set edilmiş olarak backende gönderiliyor.
      const event = new Event('input', { bubbles: true });
      $('#rate-value').val(this.value)
      let vue_input = $('#rate-value')
      vue_input.get(0).dispatchEvent(event);
      //////

      if (this.settings.change_once)
      {
        this.settings.readonly = true;
      }
      this.updateServer();

      /*
       * After change event
       */
      var change_event = $(this.element).trigger("afterChange", {
        "from": old_value,
        "to": this.value
      });

      /*
       * Update custom input field if provided
       */
      if (this.settings.hasOwnProperty("update_input_field_name"))
      {
        this.settings.update_input_field_name.val(this.value);
      }

    }
  }

  Rate.prototype.increment = function()
  {
    this.setValue(this.getValue() + this.settings.step_size);
  }

  Rate.prototype.decrement = function()
  {
    this.setValue(this.getValue() - this.settings.step_size);
  }

  $.fn.rate.settings = {
    max_value: 5,
    step_size: 0.5,
    initial_value: 0,
    symbols: {
      utf8_star: {
        base: '\u2606',
        hover: '\u2605',
        selected: '\u2605',
      },
      utf8_hexagon: {
        base: '\u2B21',
        hover: '\u2B22',
        selected: '\u2B22',
      },
      hearts: '&hearts;',
      fontawesome_beer: '<i class="fas fa-beer"></i>',
      fontawesome_star: {
        base: '<i class="far fa-star"></i>',
        hover: '<i class="fas fa-star"></i>',
        selected: '<i class="fas fa-star"></i>',
      },
      utf8_emoticons: {
        base: [0x1F625, 0x1F613, 0x1F612, 0x1F604],
        hover: [0x1F625, 0x1F613, 0x1F612, 0x1F604],
        selected: [0x1F625, 0x1F613, 0x1F612, 0x1F604],
      },
    },
    selected_symbol_type: 'utf8_star', // Must be a key from symbols
    convert_to_utf8: false,
    cursor: 'default',
    readonly: false,
    change_once: false, // Determines if the rating can only be set once
    only_select_one_symbol: false, // If set to true, only selects the hovered/selected symbol and nothing prior to it
    ajax_method: 'POST',
    additional_data: {}, // Additional data to send to the server
    //update_input_field_name = some input field set by the user
  };

}(jQuery, window));

var e2 = {}
var b2bc = ''
var b2bg = false
var b2bcPath = ''
var apiHost = '/api'
var apiVersion = '/v1'
var b2cDomain = false
var b2bDomain = false
var randPrm = ''
var nestedCats = {}, brands = {}, cities = {}, units = {}, variantGroups = {}, variants = {}, attrs = {}, attrValues = {}

// var randPrm = '?'+Math.random().toString(36).substr(3, 8)
if (ie) randPrm = ''

var globalData = new Vue()
function $id(id) { return document.getElementById(id) }

// START: FRONT PATHS Yani e2-page.js tarafından belirlenen routes lar
function langPath() {return (I18n.locale == I18n.defaultLocale ? '/' : '/'+I18n.locale+'/')}
function originalUrl() {return window.location.protocol + "//" + window.location.host + window.location.pathname}
function searchPath() {return langPath()+'search'}
function logoutPath() {return langPath()+'logout'}
function contactPath() {return langPath()+'contact'}
function b2cSignUpPath() {return langPath()+'b2c_user/sign_up'}
function b2cLoginPath() {return langPath()+'b2c_user/login'}
function b2cActivationPath() {return langPath()+'b2c_user/activation'}//BURASI ÇOK ÖNEMLİ BACKEND TE de aynısı tutuluyor, değişirse backend te değişmeli /app/views/mailer/b2c_user_activate.html.haml
function b2bLoginPath() {return langPath()+'b2b'}
function forgotPasswordPath(prmB2bc) { if (prmB2bc == 'b2c'){ return langPath()+'b2c_user/forgot_password' } else { return langPath()+'b2b_user/forgot_password' } }
function checkOutAsGuestPath(prmB2bc) { if (prmB2bc == 'b2c'){ return langPath()+'b2c_user/checkout_guest' } else { return langPath()+'b2b_user/checkout_guest' } }
function apiB2cCheckoutGuestPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/b2c_checkout_guest.json'}
function salespersonLoginPath() { return langPath()+'b2b_user/salesperson_login' }
function resetPasswordPath(prmB2bc) { if (prmB2bc == 'b2c'){ return langPath()+'b2c_user/reset_password' } else { return langPath()+'b2b_user/reset_password' } }//BURASI ÇOK ÖNEMLİ BACKEND TE de aynısı tutuluyor, değişirse backend te değişmeli /app/views/mailer/b2(c|b)_user_forgot_pass.html.haml
function cartPath() { if (b2bc == 'b2c'){ return langPath()+'cart' } else { return langPath()+'b2b/cart' } }
function shopAddrPath() { if (b2bc == 'b2c'){ return langPath()+'shopping/address' } else { return langPath()+'b2b/shopping/address' } }
function shopPayPath() { if (b2bc == 'b2c'){ return langPath()+'shopping/payment' } else { return langPath()+'b2b/shopping/payment' } }
function orderCompletePath() { if (b2bc == 'b2c'){ return langPath()+'shopping/order_complete' } else { return langPath()+'b2b/shopping/order_complete' } }
function themePath() { return '/themes/'+e2Conf.theme_code }
function imageBasePath() { return dbVar.cdn_url }
function myAccountInfoPath() { if (b2bc == 'b2c'){ return langPath()+'account/info' } else { return langPath()+'b2b/account/info' } }
function myAccountAddresesPath() { if (b2bc == 'b2c'){ return langPath()+'account/addresses' } else { return langPath()+'b2b/account/addresses' } }
function myAccountOpenPaymentPath() { if (b2bc == 'b2c'){ return langPath()+'account/open_payment' } else { return langPath()+'b2b/account/open_payment' } }
function myAccountOrdersPath() { if (b2bc == 'b2c'){ return langPath()+'account/orders' } else { return langPath()+'b2b/account/orders' } }
function myAccountDispatchesPath() { if (b2bc == 'b2c'){ return langPath()+'account/dispaches' } else { return langPath()+'b2b/account/dispatches' } }
function myAccountServiceFormPath() { if (b2bc == 'b2c'){ return langPath()+'account/service_forms' } else { return langPath()+'b2b/account/service_forms' } }
function myAccountServiceFormDetailsPath() { if (b2bc == 'b2c'){ return langPath()+'account/service_form_detail' } else { return langPath()+'b2b/account/service_form_detail' } }
function myAccountSerialWarrantyLookupPath() { if (b2bc == 'b2c'){ return langPath()+'account/warranty_lookup' } else { return langPath()+'b2b/account/warranty_lookup' } }
function myAccountOrderReturnPath() { if (b2bc == 'b2c'){ return langPath()+'account/order_return' } else { return langPath()+'b2b/account/order_return' } }
function myAccountOrderReturnFormPath() { if (b2bc == 'b2c'){ return langPath()+'account/order_return_form' } else { return langPath()+'b2b/account/order_return_form' } }
function myAccountRepairStatusQueryPath() { if (b2bc == 'b2c'){ return langPath()+'account/repair_status_query' } else { return langPath()+'b2b/account/repair_status_query' } }
function myAccountOpenAccountPaymentListPath() { return langPath()+'b2b/account/open_account_payment_list' }
function myAccountPendingOrderDetailsPath() { if (b2bc == 'b2c'){ return langPath()+'account/pending_orders_detail' } else { return langPath()+'b2b/account/pending_orders_detail' } }
function myAccountInvoicesPath() { if (b2bc == 'b2c'){ return langPath()+'account/orders' } else { return langPath()+'b2b/account/invoices' } }
function favoritePath() { if (b2bc == 'b2c'){ return langPath()+'account/favorites' } else { return langPath()+'b2b/account/favorites' } }
function openPaymentCompletePath() { if (b2bc == 'b2c'){ return langPath()+'account/open_payment_complete' } else { return langPath()+'b2b/account/open_payment_complete' } }
function reportHesapEktrePath() { if (b2bc == 'b2c'){ return langPath()+'reports/hesap_ekstre' } else { return langPath()+'b2b/reports/hesap_ekstre' } }
function reportVadeAnalizPath() { if (b2bc == 'b2c'){ return langPath()+'reports/vade_analiz' } else { return langPath()+'b2b/reports/vade_analiz' } }
function reportAyAlisSatisPath() { if (b2bc == 'b2c'){ return langPath()+'reports/ay_alis_satis' } else { return langPath()+'b2b/reports/ay_alis_satis' } }
// END: FRONT PATHS Yani e2-page.js tarafından belirlenen routes lar


// Rails BACKEND PATHS START:
function apiLangPath() {return '/'+I18n.locale}
// BACKEND GET 
// function termsAndConditionsPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/text_templates/terms_and_conditions'}
function contractPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/contracts'}
function globModelScriptPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/global_models.js'}
function currencyScriptPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/currencies.js'}
function apiCodeImagePath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/code_image'}
// BACKEND POST buranın altındakilerin %90 nı post
function apiBlockPath(id) {return apiHost+apiLangPath()+apiVersion+'/data'+'/blocks/'+id}
function apiB2cSignUpPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/b2c_sign_up.json'}
function apiB2cLoginPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/b2c_signin.json'}
function apiB2bLoginPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/b2b_signin.json'}
function apiB2bSalespersonLoginPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/salesperson_signin.json'}
function apiB2bUpdateBalancePath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/b2b_update_balance.json'}
function apiRefreshPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/refresh'}
function apiLogoutPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/logout.json'}
function apiProductsPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/products.json'}
function apiDiscountsPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/products/discounts.json'}
function apiLiveSearchPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/products/live_search.json'}
function apiAddToCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/add.json'}
function apiAddToPromotionPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/add_promotion.json'}
function apiApplyPromotionPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/apply_promotion.json'}
function apiAddMultipleToCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/add_multiple.json'}
function apiAddFromExcelToCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/add_from_excel.json'}
function apiEmptyCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/empty_cart.json'}
function apiUpdateCartItemsPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/update.json'}
function apiSendCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/send_cart.json'}
function apiQuickOrderPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/quick_order.json'}
function apiUpdatePayPlanCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/update_payment_plan.json'}
function apiUpdateCartItemWithSpDiscPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/carts/update_cart_item_with_sp_disc.json'}
function apiAddAddrPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/addresses.json'}
function apiDelAddrPath(id) {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/addresses/'+id+'.json'}
function apiCargoCalculatePricePath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/cargo/calculate_price.json'}
function apiCargoCalcPayAtDoorPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/cargo/calc_pay_at_door.json'}
function apiSendAddrToCartPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/addresses/send_addr_to_cart.json'}
function apiShoppingPayPath(action) {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/shopping/'+action}
function apiPaymentCalcDiscPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/payments/calc_payment_discount.json'}
function apiOpenPaymentPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/payments/open_payment.json'}
function apiFormContactPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/forms/contact.json'}
function apiFormB2bApplicationPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/forms/b2b_application.json'}
function apiFormGeneralPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/forms/general.json'}

function apiReportHesapEktrePath() { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/hesap_ekstre' }
function apiReportVadeAnalizPath() { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/vade_analiz' }
function apiReportAyAlisSatisPath() { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/ay_alis_satis' }
function apiReportSiparisFisiPath(key) { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/siparis_fisi'+'?key='+key }//siparişlerimden post ediliyor
function apiReportIrsaliyeFisiPath(key) { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/irsaliye_fisi'+'?key='+key }//irsaliyer post ediliyor
function apiReportFaturaFisiPath(key) { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/fatura_fisi'+'?key='+key }//faturalardan post ediliyor

function apiAccountInfoPath() { return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/info' }
function apiAccountShowOrderPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/order_detail'}
function apiAccountServiceFormShowPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/service_form_detail'}
function apiAccountOrderReturnPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/order_return'}
function apiAccountOrderReturnFormPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/order_return_form'}
function apiAccountRepairStatusQueryPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/repair_status_query'}
function apiForgotPasswordPath(prmB2bc) {return apiHost+apiLangPath()+apiVersion+'/data'+'/'+prmB2bc+'/user/forgot_password'}
function apiResetPasswordPath(prmB2bc) {return apiHost+apiLangPath()+apiVersion+'/data'+'/'+prmB2bc+'/user/reset_password'}
function apiCodesPath() {return apiHost+apiLangPath()+apiVersion+'/data'+'/codes'}
function apiAddReviewPath(prmB2bc) {return apiHost+apiLangPath()+apiVersion+'/data/'+ prmB2bc+'/reviews'}//post create
function apiProdShowInstallmentsPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/products/installment_table'}
function apiProdOldPricesPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/products/old_orders_price'}
function apiEInvoicePdfPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/e_invoice_pdf'}
function apiEDispatcPdfPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/e_dispatch_pdf'}
function apiWarrantyLookupPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/warranty_lookup_detail'}
function apiESubscribePath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/user/newsletter_subscribe'}
function apiToggleFavoritePath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/toggle_favorite'}
function apiNotifyWhenStockPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/stock_alert'}
function apiNotifyWhenPriceDownPath() {return apiHost+apiLangPath()+apiVersion+'/data'+b2bcPath+'/account/price_alert'}


// var apiV2Path = '/v2' Geliştirilmeli mantığı oturtulmadı
// function blogPath(action, id) {return apiHost+apiLangPath()+apiV2Path+b2bcPath+'/blogs'+(action||id ? '/'+action : '')+'.json'}
// V2 function apiB2bReportPath(action, key) { return apiHost+apiLangPath()+apiVersion+'/data'+'/reports/action'+(key ? '?key=' : '') }//faturalardan post ediliyor

// Rails BACKEND PATHS END:





var topView = function() {return $id('topView')}
var middleTopView = function() {return $id('middleTopView')}
var middleRow = function() {return $id('middleRow')}
var leftView = function() {return $id('leftView')}
var middleView = function() {return $id('middleView')}
var rightView = function() {return $id('rightView')}
var middleBottomView = function() {return $id('middleBottomView')}
var bottomView = function() {return $id('bottomView')}

var emptyCartData = { cart: {qty_count:0, item_count:0}, cart_items: [] }
var emptyAddrData = { address1: '', address2: '', invoice_type: '' }

function r(f){/in/.test(document.readyState)?setTimeout('r('+f+')',9):f()}//jquerysiz document ready
function setGlobData() {
  if (!localStorage.b2cCart) { localStorage.b2cCart = JSON.stringify(emptyCartData) }
  if (!localStorage.b2bCart) { localStorage.b2bCart = JSON.stringify(emptyCartData) }
  globalData = new Vue({
    data: {
      b2cSignedIn: localStorage.b2cSignedIn, b2bSignedIn: localStorage.b2bSignedIn, salespersonSignedIn: localStorage.salespersonSignedIn,
      b2cCart: JSON.parse(localStorage.b2cCart), b2bCart: JSON.parse(localStorage.b2bCart),
      isFpPage: null,
      paymentPlanId: JSON.parse(localStorage.paymentPlanId || null)
    }
  })
}
function setB2cLogin(rdata) {localStorage.csrf = rdata.csrf; localStorage.b2cSignedIn = globalData.$data.b2cSignedIn = true; setB2cUserData(rdata)}
function setB2bLogin(rdata) {localStorage.csrf = rdata.csrf; (rdata.b2bUserData.forceResetPassword && !salespersonSignedIn()) ? localStorage.b2bSignedIn = globalData.$data.b2bSignedIn = false : localStorage.b2bSignedIn = globalData.$data.b2bSignedIn = true; setB2bUserData(rdata)}
function setSalespersonLogin(rdata) {localStorage.salespersonSignedIn = globalData.$data.salespersonSignedIn = true; setSalesPersonData(rdata)}
function setB2cUserData(rdata) {localStorage.b2cUserData = JSON.stringify(rdata.b2cUserData)}
function setB2bUserData(rdata) {localStorage.b2bUserData = JSON.stringify(rdata.b2bUserData)}
function setSalesPersonData(rdata) {localStorage.salesPersonData = JSON.stringify(rdata)}
function setSpB2bUsersData(rdata) {localStorage.spB2bUsers = JSON.stringify(rdata)}
function getB2cUserData() {return JSON.parse(localStorage.b2cUserData)}
function getB2bUserData() {return JSON.parse(localStorage.b2bUserData)}
function getSalesPersonData() {return JSON.parse(localStorage.salesPersonData || '{}')}
function getSpB2bUsersData() {return JSON.parse(localStorage.spB2bUsers || '{}')}
function deleteB2cUserData() {
  delete localStorage.csrf; delete localStorage.b2cSignedIn; delete localStorage.b2cUserData; globalData.$data.b2cSignedIn = null
  localStorage.b2cCart = JSON.stringify(emptyCartData); updateCartDetail()
}
function deleteB2bUserData() {
  delete localStorage.csrf; delete localStorage.b2bSignedIn; delete localStorage.b2bUserData; globalData.$data.b2bSignedIn = null
  localStorage.b2bCart = JSON.stringify(emptyCartData); updateCartDetail()
  delete localStorage.salespersonSignedIn; delete localStorage.salesPersonData; globalData.$data.salespersonSignedIn = null
}

function b2cSignedIn(){return JSON.parse(globalData.$data.b2cSignedIn || false)}
function b2bSignedIn(){return JSON.parse(globalData.$data.b2bSignedIn || false)}
function salespersonSignedIn(){return JSON.parse(globalData.$data.salespersonSignedIn || false)}
function setGDataPaymentPlanId(id){localStorage.paymentPlanId = JSON.stringify(id); globalData.$data.paymentPlanId = id}


function getCartDetail(){
  return eval('globalData.$data.'+b2bc+'Cart')
}
function updateCartDetail(){
  eval('globalData.$data.'+b2bc+'Cart = JSON.parse(localStorage.'+b2bc+'Cart)')
}

function setCartDetail(cartDetail){
  var limitedCartDetail = jsonCopy(cartDetail)
  if (limitedCartDetail.cart_items.length > 50) {
    limitedCartDetail.cart_items = limitedCartDetail.cart_items.slice(0, dbVar.cart_preview_limit)//localStorage ta tutulacak sepet ürünleri sınırlanıyor 50 standart
  }
  eval('localStorage.'+b2bc+'Cart = JSON.stringify(limitedCartDetail)')
  eval('globalData.$data.'+b2bc+'Cart = limitedCartDetail')
}

function setDomain() {
  if (e2Conf.b2cDomain.indexOf(window.location.hostname) != -1) b2cDomain = true
  if (e2Conf.b2bDomain.indexOf(window.location.hostname) != -1) b2bDomain = true
  if (e2Conf.b2cDomain.indexOf(window.location.hostname) == -1 && e2Conf.b2bDomain.indexOf(window.location.hostname) == -1) {
    document.body.innerHTML = 'DomainError'
    throw 'DomainError'
  }
}
function setB2bc() {
  if (e2Conf.b2c && b2cDomain == true && !b2bSignedIn()) {
    b2bc = 'b2c'
    b2bcPath = '/b2c'
  } else if (e2Conf.b2b && b2bDomain == true) {
    b2bc = 'b2b'
    b2bcPath = '/b2b'
    if (e2Conf.b2bg) {
      if (localStorage.b2bUserData && JSON.parse(localStorage.b2bUserData).forceResetPassword && !localStorage.salesPersonData) {
        b2bg = false
        b2bcPath = '/b2b'
      } else if(!b2bSignedIn()) {
        b2bg = true
        b2bcPath = '/b2bg'
      } else {
        b2bg = false
      }
    }
  }
}

function getDiscRate(pu, p, opt) {
  opt = opt || {}
  if (b2bc === 'b2c') {
    return getB2cDiscRate(pu, p, opt)
  } else {
    return getB2bDiscRate(pu, p, opt)
  }
}
function showPrice(pu, p, opt) {
  if (b2bc == 'b2c') {
    return showPriceB2c(pu, p, opt)
  } else {
    return showPriceB2b(pu, p, opt)
  }
}

function getB2cDiscRate(pu, p, opt) {
  opt = opt || {}
  if (! pu) return 0

  precision = opt.precision || 0
  opt['onlyRate'] = true
  var disc = showPriceB2c(pu, p, opt)
  return disc > 0 ? disc.toFixed(precision) : 0
}

function showPriceB2c(pu, p, opt) {
  if (! pu) return ''
  opt = opt || {}
  if (opt.incVat !== false) opt.incVat = true
  if (opt.showDisc !== true) opt.showDisc = false
  var disc = pu.b2c_discount_rate
  var amount = pu.b2c_price //kdv hariç
  if (opt.pv) {//varyant varsa
    if (opt.pv.b2c_price){//varyant fiyatı varsa bu fiyat baz alınıp indirim hesaplanacak
      disc = (1.0-(opt.pv.b2c_price/amount))*100.0
    } else if (opt.pv.b2c_discount_rate){//fiyat yoksa sadece indirim oranı dikkate alınacak
      disc = opt.pv.b2c_discount_rate
    }
  }
  if(opt.factor) {
    amount = amount / pu.factor
  }
  if (opt.onlyRate){//sadece indirim oranı isteniyorsa
    return disc
  }
  if (opt.incVat){
    amount = amount*((p.vat_rate/100.0)+1.0)
  }
  if (opt.showDisc && disc > 0.0){
    amount = amount * (100.0-disc)/100.0
  }
  var baseCurrency = currenciesIdCode[pu.b2c_currency_id]
  var targetCurrency = opt.targetCurrency || null
  return formatMoney(amount, baseCurrency, targetCurrency, opt)
}

function getB2bDiscRate(pu, p, opt) {
  opt = opt || {}
  if (!pu) return ''
  precision = opt.precision || 0
  opt['onlyRate'] = true
  var disc = showPriceB2b(pu, p, opt)
  return disc > 0 ? disc.toFixed(precision) : 0
}
function showPriceB2b(pu, p, opt) {//rails def b2b_discounted_price(pu, p, discUnits)
  if (!pu) return ''
  // console.log(opt)
  opt = opt || {}
  if (opt.incVat !== false) opt.incVat = true
  var amount = 0
  var disc_factor = 1
  var disc_rate = 0
  var std_price = pu.b2b_price || 0 //kdv hariç
  var baseCurrency = currenciesIdCode[pu.b2b_currency_id]
  var targetCurrency = opt.targetCurrency || null
  var price_card = null
  if (opt.discUnits){
    price_card = opt.discUnits[pu.id]
    if (pu.b2b_discount_rate > 0) {//b2b indirim oranı varsa, price cardı discard ediyoruz
      disc_factor = (100-pu.b2b_discount_rate) / 100
    } else if (price_card){
      var disc_price = ( price_card.inc_vat ? price_card.price / ((p.vat_rate/100.0)+1.0) : price_card.price )
      var opr = price_card.price_operation === '+' ? -1 : 1 // bindirim mi indirim mi yapıyoruz?
      disc_price = disc_price * ((100-price_card.discount_rate*opr) / 100.0)
      if (price_card.currency_id && price_card.currency_id !== pu.b2b_currency_id){
        std_curr_rate = currenciesIdRate[pu.b2b_currency_id][dbVar.exchange_rate_type]
        disc_curr_rate = currenciesIdRate[price_card.currency_id][dbVar.exchange_rate_type]
        parity = std_curr_rate / disc_curr_rate
        disc_price = disc_price / parity
        if (!opt.targetCurrency) targetCurrency = currenciesIdCode[price_card.currency_id]
      }
      disc_factor = disc_price/std_price
    } else { // indirim yoksa bayi indirimi kullanıyoruz
      disc_factor = (100-(opt.discUnits['b2b_user_discount_rate'] || 0)) / 100.0
    }
    amount = std_price * disc_factor
    disc_rate = (1.0-(disc_factor))*100.0
  } else {
    amount = std_price
  }
  if(opt.factor) {
    amount = amount / pu.factor
  }
  if (opt.priceCard) return price_card //detaylı indirim oranları discount1, discount2 gibi
  if (opt.onlyRate) return disc_rate //sadece indirim oranı isteniyorsa
  if (opt.incVat) amount = amount*((p.vat_rate/100.0)+1.0)
  if (amount === 0) return ''
  return formatMoney(amount, baseCurrency, targetCurrency, opt)
}

function formatMoney(amount, baseCurrency, targetCurrency, opt={exchange: true}) {
  opt = opt || {}
  // sipariş detayı için opt'a exchange eklendi. (sipariş detayı için exchange=false)
  opt.exchange = (typeof opt.exchange === 'undefined') ? true : opt.exchange
  var currency = baseCurrency
  targetCurrency = targetCurrency || globDataVue.$data.toCurrency //toCurrency de kullanılabilir
  if (opt.exchange && targetCurrency.length > 0) { //globalData.$data.toCurrency '' ise global olarak dövizler çevrilmeyecek anlamına geliyor ve buraya girmiyor
    amount = (amount * currenciesCodeRate[baseCurrency][dbVar.exchange_rate_type]) / currenciesCodeRate[targetCurrency][dbVar.exchange_rate_type]
    currency = targetCurrency
  }
  if (opt.onlyPrice){
    return Number(amount.toFixed(2))
  }
  // console.log(amount)
  var currencyDetail = dbVar.currencies_format[currency] ? dbVar.currencies_format[currency] : { "unit": currency, "format": "%n %u", "delimiter": ".", "precision": "2", "separator": ","}
  return I18n.toCurrency(amount, currencyDetail) //dbVar.currencies_format.TRY
}

function arrLast(arr) {return arr.slice(-1).pop()}
function windowWidth() {return window.innerWidth}
function queryHash() {return qs.parse(location.search.slice(1))}

function pagiPageUrl(page) {
  // console.log(page)
  var queryHash = qs.parse(location.search.slice(1))
  queryHash.page = page
  if (queryHash.page == '1') delete queryHash.page
  var queryString = qs.stringify(queryHash)
  if (queryString.length > 0){
    return window.location.pathname+'?'+qs.stringify(queryHash)
  } else {
    return window.location.pathname
  }
}

function vueJsEval(view){//vu içinden çağırılan body gibi stringlerin içindeki <script>leri eval eder
  var jsTags = view.getElementsByTagName('script')
  var jsStrings = []
  for (var n = 0; n < jsTags.length; n++) {
    jsStrings.push( jsTags[n].innerHTML )
  }
  if ( jsStrings.length > 0 ) eval( jsStrings.join(';') )
}
function bodyOnloadJsEval(){
  var attr = document.body.getAttribute('onload')
  typeof attr == 'function' ? attr() : eval(attr)
}
function iframeBodyOnloadJsEval(iframe){
  var attr = iframe.document.body.getAttribute('onload')
  // typeof attr == 'function' ? attr() : eval('iframe.'+attr)
  iframe.body.onload = function() {
    eval(attr)
  }
}

function getElemsMaxDistance(htmlCollection) {
  var offsetTops = []
  for (var n = 0; n < htmlCollection.length; n++) {
    offsetTops.push( getElemDistance(htmlCollection[n]) )
  }
  var largest = offsetTops[0]

  for (var i = 0; i < offsetTops.length; i++) {
    if (largest < offsetTops[i] ) {
      largest = offsetTops[i]
    }
  }
  return largest
}

var getElemDistance = function ( elem ) {
  var location = 0
  if (elem && elem.offsetParent) {
    do {
      location += elem.offsetTop
      elem = elem.offsetParent
    } while (elem)
  }
  return location >= 0 ? location : 0
}

function scrollToElem(el){
  window.scrollTo(0, getElemDistance(el)-20)
}

function spinning(target){
  if (target == null){
    target = document.getElementsByTagName("BODY")[0]
  }
  // var computedStyle = getComputedStyle(target)
  // var elementHeight = target.clientHeight // height with padding
  // var elementWidth = target.clientWidth  // width with padding
  // elementHeight -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom)
  // elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight)

  var elementWidth = target.offsetWidth
  var elementHeight = target.offsetHeight

  // var indicator = '<table class="spinning-loading" style="width:'+elementWidth+'px; height:'+elementHeight+'px;"><tr><th></th></tr></table>'
  var indicator = '<span class="spinning-loading" style="width:'+elementWidth+'px; height:'+elementHeight+'px;"></span>'
  target.insertAdjacentHTML('afterbegin', indicator)
  target.style.position = 'relative'
}
function spinningRemove(){
  removeElementsByClass('spinning-loading')
}
function removeElementsByClass(className){
  var elements = document.getElementsByClassName(className)
  while(elements.length > 0){
    elements[0].parentNode.removeChild(elements[0])
  }
}

function rangeBetwee(lowEnd, highEnd){
  var list = []
  while(lowEnd <= highEnd){
    list.push(lowEnd++)
  }
  return list
}

slugifyTr = function(text) {
  // var trMap = {
  //   'çÇ':'c',
  //   'ğĞ':'g',
  //   'şŞ':'s',
  //   'üÜ':'u',
  //   'ıİ':'i',
  //   'öÖ':'o'
  // }
  // for(var key in trMap) {
  //   text = text.replace(new RegExp('['+key+']','g'), trMap[key])
  // }
  // return text.replace(/[^-a-zA-Z0-9\s]+/ig, '') // remove non-alphanumeric chars
  //            .replace(/\s/gi, "-") // convert spaces to dashes
  //            .replace(/[-]+/gi, "-") // trim repeated dashes
  //            .toLowerCase()
  return text
}

function objMerge(obj, src) {
  Object.keys(src).forEach(function(key) { obj[key] = src[key] })
  return obj
}
function getAttrFromObj(objs, id, col){
  var selectObj = objs.filter(function (obj) {return obj.id == id})[0]
  return (selectObj ? selectObj[col] : null)
}
function getObjFromObjs(objs, id){
  var selectObj = objs.filter(function (obj) {return obj.id == id})[0]
  return (selectObj ? selectObj : null)
}
// function getLocaleAttr(obj, attr){
//   return I18n.locale
// }
function getCityName(city_id) {
  return getAttrFromObj(cities, city_id, 'name')
}
function ccYearsObjs(){
  var startYear = new Date().getFullYear()
  var currentYear
  var obj = []
  for(var i = 0; i <= 15; i++) {
    currentYear = startYear + i
    obj.push({val: currentYear.toString().slice(2), text: currentYear})
  }
  return obj
}
function ccMonths(){
  return ['01','02','03','04','05','06','07','08','09','10','11','12']
}

function catsFilter(cats, _key, _val){//nestedCats içinde _key='id', _val=115 sonucu kategori objesini alabileceğimiz func
  var _result = null
  function _catsFilter(cats, _key, _val){
    for(var i=0; i<cats.length; i++){
      var cat = cats[i]
      if(cat[_key] == _val){
        //console.log(cat[_key],_val, (cat[_key] == _val))
        _result = cat
      }
      if (cat.children.length > 0) {
        _catsFilter(cat.children, _key, _val)
      }
    }
  }
  _catsFilter(cats, _key, _val)
  return _result
}

function variantGroupsFilter(groupIds) {
  var resultArr = []
  for(var i=0; i<variantGroups.length; i++) {
    var vg = variantGroups[i]
    if (groupIds.includes(vg.id)) {
      resultArr.push( getObjFromObjs(variantGroups, vg.id) )
    }
  }
  return resultArr
}

function productVariantsFilter(productVariants, varyantGroupId){
  var resultArr = []
  for(var vi=0; vi<variants.length; vi++) {
    var v = variants[vi]
    for(var pvi=0; pvi<productVariants.length; pvi++) {
      var pv = productVariants[pvi]
      if ( v.variant_group_id == varyantGroupId && pv.variant_ids.includes(v.id) ) {
        var variant = getObjFromObjs(variants, v.id)
        if (!resultArr.includes(variant)) {
          resultArr.push(variant)
        }
      }
    }
  }
  return resultArr
}
function varinatStockCal(productVariants, varArr){
  //console.log(productVariants, varArr)
  var amount = 0
  productVariants.forEach(function(pv){
    if ( arrayContainsArray(pv.variant_ids, varArr) ) {
      amount += pv[b2bc + "_stock_qty"]
    }
  })
  return amount
}

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}
Date.prototype.addMonths = function(days) {
  var date = new Date(this.valueOf())
  date.setMonth(date.getMonth() + days)
  return date
}
function getExtension(fileStr){
  var re = /(?:\.([^.]+))?$/
  return ext = re.exec(fileStr)[1]
}

function getImgVerUrl(image, version){ // aynısı general function def get_img_ver_url(image, version)
  version = version || ''
  if (version.length > 0) {
    if (version === 'thumb' && dbVar.image_versions.includes('thumb')){
      version = 'thumb'
    } else if (version === 'medium' && dbVar.image_versions.includes('medium')){
      version = 'medium'
    } else if (version === 'watermark') {
      version = 'water'
    } else {
      version = ''
    }
    if (version.length > 0) version = '_'+version
  }
  if (image && image.image){
    var fileExt = '.'+getExtension(image.image)
    var fileName = image.image.replace(fileExt, '')
    var fingerprint = String(dbVar.image_fingerprint).length > 0 ? '?'+dbVar.image_fingerprint : ''
    return imageBasePath()+'/image/'+image.id+'/'+fileName+version+fileExt+fingerprint
  } else {
    if(dbVarImg.image_not_available) {
      return dbVarImg.image_not_available
    } else {
      return '/images/image_not_available.png'
    }
  }
  // 'https://b2bc.ams3.cdn.digitaloceanspaces.com/ofises/image/1174/221407_medium.jpg'
  // 'https://b2bc.ams3.cdn.digitaloceanspaces.com/ofises/image/1174/221407.jpg'
}
function getImageUrl(id, path, type, version) {
  version = version || ''
  if (version.length > 0) version = '_'+version
  if (path){
    var fileExt = '.'+getExtension(path)
    var fileName = path.replace(fileExt, '')
    return imageBasePath()+'/'+type+'/'+id+'/'+fileName+version+fileExt
  } else {
    if(dbVarImg.image_not_available) {
      return dbVarImg.image_not_available
    } else {
      return '/images/image_not_available.png'
    }
  }
}

var serializeHash = function(array){
  var obj = {}
  for(i=0; i<array.length; i++){
    var a = array[i]
    var name = a.name
    var value = a.value
    obj[name] = value
  }
  return obj
}
//[1,2,3].incl(2)
Array.prototype.incl = function(val) {
  var arr = this.valueOf()
  if (arr.indexOf(val) != -1) {
    return true
  } else {
    return false
  }
}
function arrRemove(array, element) {
  return array.filter(function (el) {
    return el !== element
  })
}
function arrObjRemove(array, element) {
  var index = array.indexOf(element)
  if (index !== -1) {
    array.splice(index, 1)
  }
}
//Bir diziyi belli uzunlukta bölümlere ayırır
function chunkArray(myArray, chunk_size){
  var index = 0
  var arrayLength = myArray.length
  var tempArray = []
  for (index = 0; index < arrayLength; index += chunk_size) {
    myChunk = myArray.slice(index, index+chunk_size)
    tempArray.push(myChunk)
  }
  return tempArray
}
function contains(src, str){
  return src.indexOf(str) !== -1
}
function isBlank(str) {
  return (!str || /^\s*$/.test(str))
}
// Returns TRUE if the first specified array contains all elements from the second one. FALSE otherwise.
function arrayContainsArray(superset, subset) {
  if (0 === subset.length) {
    return false
  }
  //console.log(subset)
  return subset.every(function (value) {
    return (superset.indexOf(value) >= 0)
  })
}
function arraysEqual(a1, a2) {
  if (a1.length !== a2.length) {
    return false
  }
  return a1.every(function(value, index) {
    return a2.indexOf(value) > -1
  })
}

function setRedirectPath(){
  var path = window.location.pathname
  if ( path.indexOf(logoutPath()) === -1 && path.indexOf(b2cSignUpPath()) === -1 && path.indexOf(b2cLoginPath()) === -1 && path.indexOf(b2bLoginPath()) === -1 ) {
    localStorage.ref = window.location.pathname
  }
}
function getLastRedirect(){
  var redirectedPath = '/'
  if (localStorage.ref) redirectedPath = localStorage.ref
  if (contains(redirectedPath, '/shopping/')) redirectedPath = cartPath()
  if (contains(localStorage.ref, b2cActivationPath())) redirectedPath = '/'
  return redirectedPath
}
function catPathToId(path){//url deki kategori varsa id sini alıyoruz
  var i = path.lastIndexOf('-c')
  if (i != -1) {
    return parseInt( path.substr(i+2) )
  } else {
    return false
  }
}

function jsonCopy(src) {
  return JSON.parse(JSON.stringify(src))
}

function _(str) {
  return str
}

var vueTables2Conf = {
  texts: {
    filter: _('Filtrele'), filterBy: '', count:'', noResults: _('Uygun kayıt bulunamadı'), page: _('Sayfa:'), first: _('İlk'), last: _('Son'), limit: "Kayıt:"
  },
  sortIcon: { base : 'fa', is: 'fa-sort', up: 'fa-sort-asc', down: 'fa-sort-desc' }
}

function delay(callback, ms) {
  var timer = 0
  return function() {
    var context = this, args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      callback.apply(context, args)
    }, ms || 0)
  }
}

function hexToRgb(hex, resultText) {
  resultText = resultText || false
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  result = (result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null)
  return resultText ? ( result ? result.r+', '+result.g+', '+result.b : '' ) : result
}

function addToCartSuccessAlert(){
  ohSnap(
    I18n.t('generic_added_to_cart') + '<br><small><a href="'+cartPath()+'">' + I18n.t('generic_edit_cart') + '</a></small>', {color: 'success'})
}

function addToCartQtyLimitAlert(alerts= [], onlyText= false){
  var alertStr = alerts.map(x => x.msg)
  alertStr = alertStr.join('<hr class="m-1">')
  if (onlyText) {
    return stripHtml(alertStr)
  } else {
    ohSnap(I18n.t('generic_warning') + '<i class="float-right fa fa-close"></i><br><small>'+alertStr+'</small>', {color: 'warning', duration: 10000})
  }
}

function ohSnap(n,t){var o={color:null,icon:null,duration:"4000","container-id":"e2-toast","fade-duration":"fast"};t="object"==typeof t?$.extend(o,t):o;var a=$("#"+t["container-id"]),e="",i="",h="";t.icon&&(e="<span class='"+t.icon+"'></span> "),t.color&&(i="alert-"+t.color),h=$('<div class="alert '+i+'">'+e+n+"</div>").fadeIn(t["fade-duration"]),a.append(h),h.on("click",function(){ohSnapX($(this))}),setTimeout(function(){ohSnapX(h)},t.duration)}function ohSnapX(n,t){defaultOptions={duration:"fast"},t="object"==typeof t?$.extend(defaultOptions,t):defaultOptions,"undefined"!=typeof n?n.fadeOut(t.duration,function(){$(this).remove()}):$(".alert").fadeOut(t.duration,function(){$(this).remove()})}

function sessionGet(key) {
  key = (b2bcPath + key).replace(/[^a-z0-9]+|\s+/gi, '')
  var stringValue = localStorage.getItem(key)
  if (stringValue !== null) {
    var value = JSON.parse(stringValue)
    var expirationDate = new Date(value.expirationDate)
    if (expirationDate > new Date()) {
      return value.value
    } else {
      localStorage.removeItem(key)
    }
  }
  return null
}
function sessionSet(key, value, expInMin) {
  key = (b2bcPath + key).replace(/[^a-z0-9]+|\s+/gi, '')
  expInMin = expInMin || 10 // expirationInMin
  var expirationDate = new Date(new Date().getTime() + 60000 * expInMin)
  var newValue = {
    value: value,
    expirationDate: expirationDate.toISOString()
  }
  localStorage.setItem(key, JSON.stringify(newValue))
}

$(document).ready(function(){
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      $('#back-to-top').fadeIn()
    } else {
      $('#back-to-top').fadeOut()
    }
  })
  $('#back-to-top').click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 400)
    return false
  })
})
// <a id="back-to-top" href="#" class="btn btn-light btn-lg back-to-top mr-md-3 mr-2 mb-md-3 mb-2" role="button"><i class="fa fa-chevron-up"></i></a>


// ############## V2 ORTAK START ##############
var imgVerUrl = function(obj, _type, version){
  if (obj.image){
    var fileExt = '.'+getExtension(obj.image)
    console.log(fileExt)
    var fileName = obj.image.replace(fileExt, '')
    version = version ? '_'+version : ''
    return dbVar.cdn_url+'/'+_type+'/'+obj.id+'/'+fileName+version+fileExt
  } else {
    if(dbVarImg.image_not_available) {
      return dbVarImg.image_not_available
    } else {
      return '/images/image_not_available.png'
    }
  }
}
var globDataVue = new Vue({
  data: function() {
    return {
      b2bHideDiscount: JSON.parse(localStorage.b2bHideDiscount || JSON.stringify(false)),
      toCurrency: JSON.parse(localStorage.toCurrency || JSON.stringify(dbVar.to_currency))
    }
  },
  watch: {
    b2bHideDiscount: function(val){ localStorage.b2bHideDiscount = JSON.stringify(val) },
    toCurrency: function(val){ localStorage.toCurrency = JSON.stringify(val) }
  }
})
Vue.prototype.$globData = globDataVue.$data
Vue.prototype.I18n = I18n
// Vue template ten $globData.b2bHideDiscount diyerek erişebiliriz
Vue.mixin({
  methods: {
    postToCcIframe: function(target, url, data){
      var postToIframe = $('#postToIframe')
      if (postToIframe.length) postToIframe.remove()
      $('body').append('<form action="'+url+'" method="post" target="'+target+'" id="postToIframe"></form>')
      $.each(data,function(n,v){
        postToIframe.append('<input type="hidden" name="'+n+'" value="'+v+'" />')
      })
      postToIframe.submit()
      // postToIframe.submit().remove()
    }
  }
})


String.prototype.trunc = function (n) {
  return this.substr(0, n - 1) + (this.length > n ? '&hellip;' : '')
}
var stripHtml = function (html, n) {
  n = n || null
  var strippedHtml = String(html).replace(/(\r|\n|\t)/gm, "").replace(/<[^>]*>?/gm, ' ').replace(/ +(?= )/g,'')
  return n ? strippedHtml.trunc(n) : strippedHtml
}
var LATIN_MAP={"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ő":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ű":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ő":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ű":"u","ý":"y","þ":"th","ÿ":"y"},LATIN_SYMBOLS_MAP={"©":"(c)"},GREEK_MAP={"α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ά":"a","έ":"e","ί":"i","ό":"o","ύ":"y","ή":"h","ώ":"w","ς":"s","ϊ":"i","ΰ":"y","ϋ":"y","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ά":"A","Έ":"E","Ί":"I","Ό":"O","Ύ":"Y","Ή":"H","Ώ":"W","Ϊ":"I","Ϋ":"Y"},TURKISH_MAP={"ş":"s","Ş":"S","ı":"i","İ":"I","ç":"c","Ç":"C","ü":"u","Ü":"U","ö":"o","Ö":"O","ğ":"g","Ğ":"G"},RUSSIAN_MAP={"а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ё":"yo","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ё":"Yo","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya"},UKRAINIAN_MAP={"Є":"Ye","І":"I","Ї":"Yi","Ґ":"G","є":"ye","і":"i","ї":"yi","ґ":"g"},CZECH_MAP={"č":"c","ď":"d","ě":"e","ň":"n","ř":"r","š":"s","ť":"t","ů":"u","ž":"z","Č":"C","Ď":"D","Ě":"E","Ň":"N","Ř":"R","Š":"S","Ť":"T","Ů":"U","Ž":"Z"},POLISH_MAP={"ą":"a","ć":"c","ę":"e","ł":"l","ń":"n","ó":"o","ś":"s","ź":"z","ż":"z","Ą":"A","Ć":"C","Ę":"e","Ł":"L","Ń":"N","Ó":"o","Ś":"S","Ź":"Z","Ż":"Z"},LATVIAN_MAP={"ā":"a","č":"c","ē":"e","ģ":"g","ī":"i","ķ":"k","ļ":"l","ņ":"n","š":"s","ū":"u","ž":"z","Ā":"A","Č":"C","Ē":"E","Ģ":"G","Ī":"i","Ķ":"k","Ļ":"L","Ņ":"N","Š":"S","Ū":"u","Ž":"Z"},ALL_DOWNCODE_MAPS=new Array;ALL_DOWNCODE_MAPS[0]=LATIN_MAP,ALL_DOWNCODE_MAPS[1]=LATIN_SYMBOLS_MAP,ALL_DOWNCODE_MAPS[2]=GREEK_MAP,ALL_DOWNCODE_MAPS[3]=TURKISH_MAP,ALL_DOWNCODE_MAPS[4]=RUSSIAN_MAP,ALL_DOWNCODE_MAPS[5]=UKRAINIAN_MAP,ALL_DOWNCODE_MAPS[6]=CZECH_MAP,ALL_DOWNCODE_MAPS[7]=POLISH_MAP,ALL_DOWNCODE_MAPS[8]=LATVIAN_MAP;var Downcoder=new Object
function URLify(A,e){return(A=(A=(A=(A=(A=downcode(A)).replace(/[^-\w\s]/g," ")).replace(/^\s+|\s+$/g,"")).replace(/[-\s]+/g,"-")).toLowerCase()).substring(0,e)}Downcoder.Initialize=function(){if(!Downcoder.map){for(var A in Downcoder.map={},Downcoder.chars="",ALL_DOWNCODE_MAPS){var e=ALL_DOWNCODE_MAPS[A];for(var o in e)Downcoder.map[o]=e[o],Downcoder.chars+=o}Downcoder.regex=new RegExp("["+Downcoder.chars+"]|[^"+Downcoder.chars+"]+","g")}},downcode=function(A){Downcoder.Initialize();var e="",o=A.match(Downcoder.regex);if(o)for(var r=0;r<o.length;r++){if(1==o[r].length){var _=Downcoder.map[o[r]];if(null!=_){e+=_;continue}}e+=o[r]}else e=A;return e}

var getPath = function (obj, _type) {
  if (_type === 'product') {
    return "/".concat(URLify(String(obj.name)), "-p").concat(obj.id)
  } else if (_type === 'category') {
    return "/".concat(URLify(String(obj.name)), "-c").concat(obj.id)
  } else if (_type === 'brand') {
    return "/".concat(URLify(String(obj.name)), "-b").concat(obj.id)
  } else if (_type === 'blog') {
    return "/".concat(URLify(String(obj.title)), "-l").concat(obj.id)
  } else if (_type === 'section') {
    return "/".concat(URLify(String(obj.title)), "-s").concat(obj.id)
  } else if (_type === 'promotion') {
    return "/".concat(URLify(String(obj.name)), "-r").concat(obj.id)
  }
}

var exportXlsx = function(table_id, file_name, options) {
  var exportOptions = { 'formats': ['xlsx'], 'exportButtons': false }
  var ExportButtons = document.getElementById(table_id)
  options = Object.assign(exportOptions, options)
  var instance = new TableExport(ExportButtons, options)
  var exportData = instance.getExportData()[table_id]['xlsx']
  instance.export2file(exportData.data, exportData.mimeType, dbVar.company_name + '-' + file_name, exportData.fileExtension)
}
// ############## V2 ORTAK END ##############

var blockIdPrefix = 'b';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

Array.prototype.diff = function(a) {
  return this.filter(function(i) {return a.indexOf(i) < 0;});
};

var localCache = {
  data: {},
  remove: function (id) {
    delete localCache.data[id];
  },
  exist: function (id) {
    return localCache.data.hasOwnProperty(id) && localCache.data[id] !== null;
  },
  get: function (id) {
    return localCache.data[id];
  },
  set: function (id, cachedData) {
    localCache.remove(id);
    localCache.data[id] = cachedData;
  }
};

//   var dataUrl = apiHost+apiLangPath()+apiPrefix+thisB2bcPrefix+'/layouts'+url+randPrm// localhost:8080/tr/api/v1/b2c/layouts/home
// var prevIndexType = null
function loadPageLayout(ctx, next, url, prmB2bc){
  prmB2bc = prmB2bc || b2bcPath
  if (!contains(prmB2bc,'/')) {prmB2bc = '/'+prmB2bc}
  var extraPrms = randPrm
  if (ctx.querystring.length > 0) extraPrms = ''
  var dataUrl = apiHost+apiLangPath()+apiVersion+'/layouts'+prmB2bc+url+extraPrms// localhost:8080/tr/api/v1/b2c/layouts/home
  // console.log(dataUrl)
  securedAxiosInstance.get(dataUrl)
  .then(function (response) {
    // console.log(response.data)
    rData = response.data
    if (rData.redirect) {
      var redirect_path = eval(rData.redirect)//backend ten js path dönüyor (cartPath() gibi)
      headful({ preStatus: '301', preLocation: redirect_path })
      console.log("redirecting: "+redirect_path)
      return page.redirect(redirect_path)
    } else if (rData.model_pathname && rData.model_pathname != ctx.pathname) {
      var queryPrms = ''
      if (ctx.querystring.length > 0) queryPrms = '?'+ctx.querystring
      var newlocation = rData.model_pathname+queryPrms
      window.history.pushState({path: newlocation}, document.title, newlocation)
      // page.redirect(newlocation)
      headful({ preStatus: '301', preLocation: newlocation })
      console.log("redirecting: "+newlocation)
    }
    headful({
      lang: I18n.locale,
      title: rData.meta_title || rData.heading,
      description: rData.meta_description,
      relCanon: rData.model_pathname,
      relNext: (rData.rel_next ? pagiPageUrl(rData.rel_next) : null),
      relPrev: (rData.rel_prev ? pagiPageUrl(rData.rel_prev) : null),
      robots: location.host.includes('diaeticaret') ? 'noindex, nofollow' : rData.robots
    });

    setLayout(ctx, next, rData.layout)
  })
  .catch(function (e) {
    // if (e.response.status === 404) alert('404')
    console.log(e)
  })
}


var cratedBlocksIds = []

function setLayout(ctx, next, layout){
  // Bu sistem artık sadece orta bölüm harici kullanılıyor
  // Sayfadaki önceden yaratılmış blocklar yeni gelen layout dekilerle karşılaştırılıyor, yoksa sayfadan kaldırılıyor
  if (cratedBlocksIds.length) {
    var layoutBlocksIds = []
    layout.blocks.forEach(function(block) {
      // if (block.position.indexOf('middle') == -1) layoutBlocksIds.push(blockIdPrefix+block.id+I18n.locale)
      if (block.position == 'middle') layoutBlocksIds.push(blockIdPrefix+block.id+I18n.locale)
    })
    hiddenBlocksIds = cratedBlocksIds.diff(layoutBlocksIds)
    // console.log(cratedBlocksIds); console.log(layoutBlocksIds);console.log(hiddenBlocksIds)
    hiddenBlocksIds.forEach(function(hideId) {
      // console.log(hideId)
      element = $id(hideId)
      if (element) element.style.display = "none"
    })
    cratedBlocksIds = [].concat(_toConsumableArray(new Set(cratedBlocksIds)))//yaratılmış elementleri uniq yapıyoruz
  }


  if (layout.show_left_block == false) {
    leftView().classList.add('d-none')
    // page.exit(function(ctx, next) {
    //   leftView().classList.remove('d-none')
    //   next()
    // })
  } else {
    leftView().classList.remove('d-none')
  }
  return blockLoad(ctx, next, layout)
}


function blockLoad(ctx, next, layout){
  layout.blocks.forEach(function(block) {
    var view = undefined
    if (block.position == 'top') { view = topView() }
    else if (block.position == 'middle_top') { view = middleTopView() }
    else if (block.position == 'left') { view = leftView() }
    else if (block.position == 'middle') { view = middleView() }
    else if (block.position == 'right') { view = rightView() }
    else if (block.position == 'middle_bottom') { view = middleBottomView() }
    else if (block.position == 'bottom') { view = bottomView() }

    var blockUrl = apiBlockPath(block.id)
    var blockId = blockIdPrefix+block.id+I18n.locale
    var blockEl = $id(blockId)//önceden oluşturulmuş block elementi
    var load = false

    if (block.position == 'middle' && localCache.exist(blockId)) {//orta kısımlar her seferinde yeniden mount oluyor
    // if (block.position.indexOf('middle') != -1 && localCache.exist(blockId)) {//orta kısımlar her seferinde yeniden mount oluyor
      $(view).html( localCache.get(blockId) )
    } else if (blockEl){
      blockEl.style.display = ""
      if (e2Conf.blockCache == false) load = true
    } else {
      load = true
      blockEl = document.createElement('div')
      blockEl.setAttribute('id', blockId)
      cratedBlocksIds.push(blockId)
    }

    if (load) {
      blockEl.innerHTML = ''
      // console.log(block)
      securedAxiosInstance.get(blockUrl+'.json')
      .then(function (response) {
        var responseData = response.data.replace(/\@layout_id/g, 'f'+layout.id)//vue id uniq olması için @layout id layout.id ye çevriliyor f5_b11 gibi
        // blockEl.innerHTML = responseData
        // jsEval(blockEl)
        if (block.position == 'middle') {//orta kısımlar her seferinde yeniden mount oluyor
        // if (block.position.indexOf('middle')indexOf('middle') != -1) {//orta kısımlar her seferinde yeniden mount oluyor
          localCache.set(blockId, responseData)
          $(view).html( responseData )
        } else {
          view.appendChild(blockEl)
          $(blockEl).html( responseData )//jquery
        }
      })
      .catch(function (e) {
        console.log(e)
      })
    }
  })
  // console.log('afterBlocksLoaded(ctx)')
  // ieAfterBlockLoad()
  return afterBlocksLoaded(ctx)
}

function afterBlocksLoaded(ctx){
  e2Alert.notice = e2Alert.alert = null//alertler siliniyor
  if (window.ga && ga.create) {
    ga('set', 'page', ctx.path);
    ga('send', 'pageview');
  }
  if (window.gtag && window.gaTrackingId) {
    gtag('config', gaTrackingId, {'page_path': ctx.path});
  }
  if (ctx.path.indexOf('page=') !== -1 || ctx.pathname.indexOf(searchPath()) !== -1) {
    // window.scrollTo(0, getElemDistance(middleView()) + dbVar.pagination_top_margin)
    $('html, body').scrollTop(getElemDistance(middleView()) + dbVar.pagination_top_margin)
  } else {
    // window.scrollTo(0, 0)
    $('html, body').scrollTop(0)
  }


  // // window.scrollTo(0, 0)
  // // sessionStorage a scroll varsa o sayfaya ait scroll yapıyoruz
  // window.onpopstate = (e) => {
  //   let oldScrollY = Number(sessionStorage.getItem("scrollPosY_" + ctx.pathname))
  //   if (oldScrollY) {
  //     window.scrollTo(0, oldScrollY)
  //   }
  // }
  // // ctx.init sadece tüm sayfa yüklenince ve geri butonuna basınca çalışıyor bu
  // // bu şekilde sayfa gezilerek gittiğini anlıyoruz
  // if (!ctx.hasOwnProperty('init')) {
  //   if (ctx.path.indexOf('page=') !== -1 || ctx.pathname.indexOf(searchPath()) !== -1) {
  //     // window.scrollTo(0, getElemDistance(middleView()) + dbVar.pagination_top_margin)
  //     $('html, body').scrollTop(getElemDistance(middleView()) + dbVar.pagination_top_margin)
  //   } else {
  //     window.scrollTo(0, 0)
  //     // $('html, body').scrollTop(0)
  //   }
  // }

  return afterBlocksLoadedCustom(ctx)
}

function afterBlocksLoadedCustom(ctx){
  //boş fonksiyon ön tarafta ihtiyaç doğrultusunda kullanmak için
}

var loadedJsSrcs = []
function jsEval(view){//axios ile yüklenen verilerin içindeki js leri eval eder
  var jsTags = view.getElementsByTagName('script')
  var jsStrings = []
  var jsSrcs = []

  for (var n = 0; n < jsTags.length; n++) {
    var jsTag = jsTags[n];
    if ( jsTag.hasAttribute('src') ) {
      if ( loadedJsSrcs.indexOf(jsTag.getAttribute('src')) == -1 ) {
        jsSrcs.push( axios.get( jsTag.getAttribute('src') ) );
        // console.log(jsTag.getAttribute('src'))
      }
    } else {
      jsStrings.push( jsTag.innerHTML )
    }
  }

  if ( jsSrcs.length > 0 ) {//js src leri tekrar çekip eval ediyoruz
    axios.all(jsSrcs).then(function(results) {
      results.forEach(function(response) {
        loadedJsSrcs.push(response.config.url)
        // console.log(response.config.url)
        eval(response.data);
      })
    })
  }
  // console.log(jsStrings.join(';'))
  if ( jsStrings.length > 0 ) eval( jsStrings.join(';') )//script tagi içindeki js ler eval ile çalıştırılıyor
}

// function ieAfterBlockLoad() {
  // $("a:not([target])").click(function(e){
  //   if( location.hostname === this.hostname || !this.hostname.length ) {
  //     console.log('Gergergt')
  //     page($(this).attr('href'))
  //     e.preventDefault()
  //   }
  // })
// }
var paymentPlanMixin = {
  data() {
    if (dbVar.reset_pay_plans) {
      return {
        paymentPlanId: e2.paymentPlans[0].id
      }
    } else {
      return {
        paymentPlanId: globalData.$data.paymentPlanId
      }
    }
  },
  methods: {
    setCartPaymentPlan(cart_update= false) {
      if (e2Conf.payment_plan && e2.paymentPlans.length > 0) {
        spinning()
        securedAxiosInstance.post(apiUpdatePayPlanCartPath(), {payment_plan_id: this.paymentPlanId})
          .then(response => {
            if (cart_update) {
              spinningRemove()
              setGDataPaymentPlanId(this.paymentPlanId)
              var cartDetail = response.data
              this.cartItems = cartDetail.cart_items
              this.cart = cartDetail.cart
              setCartDetail(cartDetail)
            }
          })
          .catch(function (e) {
            console.log(e)
          })
      }
    },
    setPaymentPlans() {
      // açık hesap kullanmasına izin verilmediyse ödeme planlarından ödeme tipi açık hesap olanlar çıkarılıyor
      if (e2Conf.payment_plan && e2.paymentPlans.length > 0) {
        if (b2bSignedIn()) {
          const b2b_user_data = getB2bUserData()
          if (b2b_user_data.payment_privileges.includes('credit_card') && b2b_user_data.payment_privileges.length == 1 )
            e2.paymentPlans = e2.paymentPlans.filter(x => parseInt(x.pay_type) !== 1)
          if (b2b_user_data.payment_plans.length)
            e2.paymentPlans = e2.paymentPlans.filter(x => b2b_user_data.payment_plans.includes(x.id))
        }
        if (!globalData.$data.paymentPlanId || !e2.paymentPlans.find(x => x.id === globalData.$data.paymentPlanId)) { setGDataPaymentPlanId(e2.paymentPlans[0].id) }
      }
    },
    setProdShowPaymentPlan() {
      if (dbVar.reset_pay_plans) {
        setGDataPaymentPlanId(e2.paymentPlans[0].id)
      } else {
        setGDataPaymentPlanId(this.paymentPlanId)
      }
      this.getPaymentPlanPrices()
     },
    getPaymentPlanPrices() {
      securedAxiosInstance.get(apiDiscountsPath() + '?product_id=' + this.product.id + '&payment_plan_id='+ this.paymentPlanId)
        .then(response =>  {
          this.discUnits = response.data.discounted_units
        }).catch(function (error) {
        return console.log(error)
      })
    }
  },
  mounted() {
    if (dbVar.reset_pay_plans) {
      this.setProdShowPaymentPlan
    }
    this.setPaymentPlans()
  }
}

var favoriteMixin = {
  data() {
    return {
      favorite: false,
      favorites: []
    }
  },
  methods: {
    toggleFavoriteStatus(product_id) {
      var _this = this
      product_id = parseInt(product_id)
      securedAxiosInstance.post(apiToggleFavoritePath(), {product_id: product_id})
        .then((response) => {
          if (response.data.code === 200) {
            var userData = b2bc === 'b2c' ? getB2cUserData() : getB2bUserData()
            if (_this.product) {
              _this.favorite = !_this.favorite
              if (_this.favorite) {
                userData['favorites'].push(product_id)
              } else {
                userData['favorites'] = arrRemove(userData['favorites'], product_id)
              }
              this.favorites = userData['favorites']
            } else {
              var fav = _this.favorites.includes(product_id)
              if (fav) {
                _this.favorites = arrRemove(_this.favorites, product_id)
              } else {
                _this.favorites.push(product_id)
              }
              userData['favorites'] = _this.favorites
            }
            b2bc === 'b2c' ? setB2cUserData({'b2cUserData': userData}) : setB2bUserData({'b2bUserData': userData})
            ohSnap(response.data.msg + '<br><small><a href="'+favoritePath()+'">'+ I18n.t('account_favorites') +'</a></small>', {color: 'warning'})
          } else {
            alert(response.data.msg)
          }
        })
        .catch((e) => {
          if (e.response.status) {
            alert(I18n.t('generic_please_login'))
          } else {
            alert(I18n.t('generic_error'))
          }
          console.log(e)
        })
    }
  },
  mounted() {
    var _this = this
    if (dbVar[b2bc + '_use_favorite'] && eval(b2bc + 'SignedIn')()) {
      //backendden loginde gelen favori ürünler listeye atılıyor
      var userData = b2bc === 'b2c' ? getB2cUserData() : getB2bUserData()
      _this.favorites = userData['favorites']
      //ürün detayda favorinin set edilmesi
      if (_this.product) {
        _this.favorite = _this.favorites.find(x => x == parseInt(_this.product.id)) ? true : false
      }
    }
  }
}

var productListMixin = {
  mixins: [paymentPlanMixin],
  data: function() {
    return {
      products: jsonapi.parse(rData.products).data,
      codes: rData.codes,
      pagination: rData.pagination,
      discUnits: rData.discounted_units,
      breadcrumb: rData.breadcrumb,
      priceRules: rData.price_rules
    }
  }
}

var schemaJsonMixin = {
  methods: {
    reviewHashCreator: function(review) {
      return {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue" : review.rate,
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": `${review.show_name ? review.user.name : 'User'}`
        }
      }
    },
    schemaCreator: function() {
      let schemaHash = {
        "@context": "https://schema.org",
        "@type": "Product",
        "description": this.product.meta_description || '',
        "name": this.product.meta_title || this.product.name,
        "image": this.product.images.length > 0 ? this.product.images.map((image) => image.url ? image.url : '') : getImageUrl(),
        "sku": this.product.stock_code,
        "category": rData.breadcrumb.length > 1 ? rData.breadcrumb.at(-2).name : '',
        "offers": {
          "@type": "Offer",
          "availability": this.product[`${b2bc}_in_stock`] || dbVar[`${b2bc}_out_of_stock_order`] ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
          "price": showPrice(this.product.units[0], this.product, {incVat: true, onlyPrice: true, targetCurrency: currenciesIdCode[this.product.units[0][`${b2bc}_currency_id`]], showDisc: true}),
          "priceCurrency": currenciesIdCode[this.product.units[0][`${b2bc}_currency_id`]],
          "url": window.location.href,
          "itemCondition": "http://schema.org/NewCondition",
        },
        "brand": {
          "@type": 'Brand',
          "name": this.brand.name || "",
        },
      }
      if (rData.reviews.length > 0) {
        schemaHash.aggregateRating = {
          "@type": "AggregateRating",
          "ratingValue": rData.avg_rate,
          "reviewCount": rData.all_reviews_count
        }
        schemaHash.review = rData.reviews.map((review) => {
          return this.reviewHashCreator(review);
        })
      }
      return schemaHash;
    },
  },
  mounted() {
    if (b2bc === 'b2c') {
      const schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.innerHTML = JSON.stringify(this.schemaCreator());
      this.$el.appendChild(schemaScript);
    }
  }
}

var productShowMixin = {
  mixins: [epMix.prd.sliderFotorama, paymentPlanMixin, schemaJsonMixin],
  data: function() {
    return {
      breadcrumb: rData.breadcrumb,
      product: jsonapi.parse(rData.product).data,
      codes: rData.codes,
      discUnits: rData.discounted_units,
      priceRules: rData.price_rules,
      brand: {},
      fpu: {},
      newReview: {'rate': 1},
      reviews: rData.reviews,
      reviewLimit: 4,
      reviewShowAll: false,
      all_reviews_count: rData.all_reviews_count,
      avg_rate: rData.avg_rate,
      lastVisitPages: [],
      virtualPos: [],
      bestInstallPrice: Object,
      oldPrices: []
    }
  },
  beforeMount: function() {
    this.product.units.map(function (pu) { return pu.qty = 1 })
    this.brand = getObjFromObjs(brands, this.product.brand_id) || {}
    this.fpu = this.product.units[0] || {}

    if (!this.product.attrs) this.product.attrs = []
    this.product.attrs = this.product.attrs.map(function (attrValId) {
      var attrVal = getObjFromObjs(attrValues, attrValId)
      var attr = getObjFromObjs(attrs, attrVal.attr_id)
      return { attrName: attr.name, attrValName: attrVal.name, attrPriority: (attr.priority || Infinity) }
    })
    this.product.attrs.sort(function (a, b) {
      return a.attrPriority - b.attrPriority
    })
  },
  methods: {
    discRate: function(pu) {
      pu = pu || this.fpu
      return getDiscRate(pu, this.product,{discUnits: this.discUnits})
    },
    addReview: function(event) {
      var jForm = $(event.target)
      if (jForm.valid()) {
        spinning(event.target)
        securedAxiosInstance.post(apiAddReviewPath(b2bc), this.newReview)
          .then(function (response) {
            spinningRemove()
            if (response.data.code === '200') {
              return e2Alert.notice = _('Yorumunuz eklendi. Onaylandıktan sonra yayına alınacaktır.')
            } else {
              e2Alert.alert = null
              e2Alert.alert = response.data.error_msg
            }
          })
          .catch(function (e) {
            spinningRemove()
            alert(I18n.t('generic_error_cannot_be_added'))
            console.log(e)
          })
      } else {
        return false
      }
    },
    getInstallmentTable: function (event) {
      var _this = this
      securedAxiosInstance.post(apiProdShowInstallmentsPath(), {})
        .then(function (res) {
          _this.virtualPos = res.data.virtual_pos
          _this.bestInstallPrice.install = 1
          _this.bestInstallPrice.fee_percent = 100.0
          _this.virtualPos.map(function (vpos){
            vpos["installments"].map(function (installment){ //Bu map en yüksek taksit sayısını bulmak için kullanıyor
              if (installment["nr_instal"] + installment["add_instal"] > _this.bestInstallPrice.install) {
                _this.bestInstallPrice.install = installment["nr_instal"] + installment["add_instal"]
              }
            })
            vpos["installments"].map(function (installment){
              //Bu map en yüksek taksit sayısı bulunduktan sonra aynı taksit sayısı olanlar ile komisyon oranlarını karşılaştırıp en düşük komisyonu buluyor.
              if (installment["nr_instal"] + installment["add_instal"] == _this.bestInstallPrice.install && _this.bestInstallPrice.fee_percent > installment["fee_percent"]) {
                _this.bestInstallPrice.fee_percent = installment["fee_percent"]
              }
            })
          })
        })
        .catch(function (e) {
          alert(I18n.t('generic_error_cannot_be_added'))
          console.log(e)
        })
    },
    getOldOrdersPrices: function (product_id) {
      var _this = this
      securedAxiosInstance.post(apiProdOldPricesPath(), {product_id: product_id})
          .then(function (res) {
            _this.oldPrices = res.data
          })
          .catch(function (e) {
            alert(I18n.t('generic_error_cannot_be_added'))
            console.log(e)
          })
    },
  },
  mounted: function() {
    var _this = this
    if (dbVar.reset_pay_plans) {
      _this.paymentPlanId = e2.paymentPlans[0].id
      _this.setProdShowPaymentPlan()
    }
    _this.newReview.product_id = _this.product.id

    var shareButton = document.querySelector('.product-navigator-share')
    if (shareButton) {
      shareButton.addEventListener('click', event => {
        if (navigator.share) {
          navigator.share({
            title: rData.heading,
            url: document.URL
          }).catch(console.error)
        }
      })
    }
  }
}

var productShowVariantMixin = {
  mixins: [epMix.prd.sliderFotorama],
  data: function() {
    return {
      productVariants: rData.product_variants,
      availableVariantGroups: [],
      selectableVariantGroups: [],
      selectedVariantIds: [],
      selectedVariantId: null,
      selectedProductVariant: null,
      varyantAlert: false,
      zoomImgThumbSrc:  '',
      zoomImgLargeSrc: '',
      cloudZoomJqId: null
    }
  },
  methods: {
    varyantChange: function(variantGroupId, varyantId, vg_i) {
      var _this = this
      this.selectedVariantIds = this.selectedVariantIds.slice(0, vg_i)
      this.selectedVariantIds.push(varyantId)
      this.selectedVariantId = varyantId
      this.selectableVariantGroups = this.availableVariantGroups.slice(0, this.selectedVariantIds.length+1)
      if (this.availableVariantGroups.length == this.selectedVariantIds.length) {
        this.selectedProductVariant = this.productVariants.filter(function (pv) {return arraysEqual(pv.variant_ids, _this.selectedVariantIds)})[0]
      } else {
        this.selectedProductVariant = null
      }
      //Cloudzoom Start
      var variantFound = false
      this.product.images.forEach(function (image) {
        if (arrayContainsArray(_this.selectedVariantIds, image.variant_ids)) {
          if (!variantFound) {
            _this.zoomImgThumbSrc = getImgVerUrl(image, 'medium')
            _this.zoomImgLargeSrc = getImgVerUrl(image)
            variantFound = true
          }
        }
      })
      if (variantFound == false) {//eğer varyanta ait resim yoksa boş yerine ilki filtreleniyor
        this.zoomImgThumbSrc = getImgVerUrl(this.product.images[0], 'medium')
        this.zoomImgLargeSrc = getImgVerUrl(this.product.images[0])
      }
      if (this.cloudZoomJqId.data('CloudZoom') != undefined) {
        this.cloudZoomJqId.data('CloudZoom').loadImage(this.zoomImgThumbSrc, this.zoomImgLargeSrc)
      }
      //Cloudzoom End

      if (this.cloudZoomJqId.data('CloudZoom') == undefined) {
        this.slider.fotorama.show(0)
        this.slider.productImages = []
        this.slider.zoomControl = []
        this.product.images.forEach(function (image) {
          if (arrayContainsArray(image.variant_ids, _this.selectedVariantIds)) {
            _this.slider.productImages.push(
                {
                  "img": getImgVerUrl(image, 'medium'),
                  "thumb": getImgVerUrl(image, 'thumb'),
                  "full": getImgVerUrl(image),
                  "index": image.id
                }
            )
          }
        })
        this.slider.fotorama.load(this.slider.productImages)
      }
    }
  },
  mounted: function() {
    this.availableVariantGroups = variantGroupsFilter(this.product.available_variant_group_ids)
    this.selectableVariantGroups = [this.availableVariantGroups[0]]
    this.zoomImgThumbSrc = this.product.images.length > 0 ? getImgVerUrl(this.product.images[0], 'medium') : themePath()+'/no-image.jpg'
    this.zoomImgLargeSrc = this.product.images.length > 0 ? getImgVerUrl(this.product.images[0]) : themePath()+'/no-image.jpg'

    //Cloudzoom Start
    CloudZoom.quickStart()
    this.cloudZoomJqId = $(this.$el).find('#productDesktopZoom').bind('cloudzoom_start_zoom', function(){
      $('.cloudzoom-lens').next().remove()
    })
    //Cloudzoom End
  }
}

var privilegesMixin = {
  data() {
    return {
      b2bUserPrivileges: [],
      salespersonPrivileges: []
    }
  },
  methods: {
    checkPrivileges: function (privilege, type){
      var privileges = type === 'salesperson' ? this.salespersonPrivileges : this.b2bUserPrivileges
      if (privileges && privileges.length === 0){
        return true
      } else {
        return privileges.includes(privilege)
      }
    },
  },
  mounted: function() {
    this.b2bUserPrivileges = getB2bUserData().privileges
    this.salespersonPrivileges = getSalesPersonData().privileges
  }
}
var addToCartMixin = {
  data() {
    return {
      notifyAlertEmail: null
    }
  },
  props: {
    origin: { default: "productList", type: String },
    cartNote: { default: null, type: String },
    dynFields: { default: Object, type: Object },
    fiveDim: { default: Object, type: Object },
    whItems: { default: Object, type: Object }
  },
  mixins: [favoriteMixin],
  methods: {
    addToCart: function(pu, event, pv, qb) { //qb quick_buy
      pu.qty = pu.qty || 1
      var _this = this
      var items = []
      var itemObj = { pu_id:pu.id, qty: pu.qty }
      if (pv) itemObj.pv_id = pv.id // variant id
      if (this.$refs.cartNote) { // sepete not ekleme
        if (this.cartNote && this.$refs.cartNote.attributes.getNamedItem("required")) {
          return e2Alert.alert = 'Not Alanı doldurulmalıdır'
        }
        itemObj.note = this.cartNote
      }
      if (this.$refs.dynFields) { // dinamik alanlar divi varsa <div ref="dynFields">
        var dynFieldsLength = Object.keys(this.dynFields).length
        if( $(this.$refs.dynFields).find('[required]').filter(function () {return $.trim($(this).val()).length === 0}).length > 0 ) {
          return e2Alert.alert = 'Dinamik Alanlar doldurulmalıdır'
        }
        if (dynFieldsLength > 0) itemObj.dyn_fields = this.dynFields
      }
      if (this.$refs.fiveDim) { // 5 boyut alanlar divi varsa <div ref="fiveDim">
        var fiveDimLength = Object.keys(this.fiveDim).length
        if( $(this.$refs.fiveDim).find('[required]').filter(function () {return $.trim($(this).val()).length === 0}).length > 0 ) {
          return e2Alert.alert = '5 Boyut Alanları doldurulmalıdır'
        }
        if (fiveDimLength > 0) itemObj.five_dim = this.fiveDim
      }
      if (this.$refs.warehouses) { // Çoklu depo varsa <div ref="warehouses">
        if (Object.keys(this.whItems).length) {
          Object.keys(this.whItems).forEach(function(key) {
            if (_this.whItems[key] > 0) items.push({pu_id:pu.id, qty: _this.whItems[key], wh_id: key}) // qty: value, wh_id: key
          })
        } else {
          return e2Alert.alert = 'Depo miktarı girilmelidir'
        }
      }
      if (!items.length) items = [itemObj] // sadece tek bir kalem sepete eklenecekse items içine atılıyor
      securedAxiosInstance.post(apiAddToCartPath(), {items: items})
        .then(function (response) {
          spinningRemove()
          var cartDetail = response.data
          if (_this.origin === 'productList') {//STANDART PRODUCT LIST
            if (response.data.alerts.length > 0) {
              addToCartQtyLimitAlert(response.data.alerts)
            } else {
              if (qb) {
                var redirectedPath = langPath() + 'cart'
                setTimeout(function () {window.location.href = redirectedPath}, 150)
              } else {
                addToCartSuccessAlert()
              }
            }
            pu.qty = ''
            setCartDetail(cartDetail)
            if (cartDetail.cart.locked) alert(I18n.t('cart_in_process'))
          } else if (_this.origin === 'cart'){ // SEPETTEN GELMİŞSE
            _this.$parent.updateCartItems(response.data)
          }
        })
        .catch(function (e) {
          spinningRemove()
          if (e.response.status === 401 && b2bg) {
            alert(I18n.t('generic_login_required'))
          } else {
            alert(I18n.t('generic_error_cannot_be_added'))
          }
        })
    },
    addMultipleToCart: function() {
      var items = []
      var prodUnits = []
      for (var pi = 0; pi < this.products.length; pi++) {
        var p = this.products[pi]
        for (var pui = 0; pui < p.units.length; pui++) {
          var pu = p.units[pui]
          if (parseFloat(pu.qty)){
            items.push( {pu_id:pu.id, qty: pu.qty} )
            prodUnits.push(pu)
          }
        }
      }
      if (items.length > 0) {
        var prodEls = document.getElementsByClassName('product-item')
        for (var i = 0; i < prodEls.length; i++) { spinning(prodEls[i]) }
        securedAxiosInstance.post(apiAddToCartPath(), {items: items})
          .then(function (response) {
            spinningRemove()
            // if (response.data.error_msg) return e2Alert.alert = response.data.error_msg
            // addToCartSuccessAlert()
            if (response.data.alerts.length > 0) {
              addToCartQtyLimitAlert(response.data.alerts)
            } else {
              addToCartSuccessAlert()
            }
            prodUnits.map( function(pu) { return pu.qty = '' } )
            var cartDetail = response.data
            if (cartDetail.cart.locked) return alert(I18n.t('cart_in_process'))
            setCartDetail(cartDetail)
          })
          .catch(function (e) {
            spinningRemove()
            if (e.response.status === 401 && b2bg) {
              alert(I18n.t('generic_login_required'))
            } else {
              alert(I18n.t('generic_error_cannot_be_added'))
            }
            console.log(e)
          })
      } else {
        spinningRemove()
      }
    },
    reduceDynFields: function (objArr, str) {
      var arr = str.split(',').filter(Boolean)
      return objArr.filter(function(df) { return arr.includes(df.col_name) })
    },
    notifyWhenStock(modal_id, product) {
      var _this = this
      var product_id
      // liste ekranından mail listesine eklenince id gelmiyordu. bu sebeple ikinci parametre eklendiyse onu product id olarak kabul diyoruz.
      product_id = product == undefined ? _this.product.id : product.id
      securedAxiosInstance.post(apiNotifyWhenStockPath(), {product_id: product_id, email: _this.notifyAlertEmail})
        .then(function (response) {
          $(_this.$el).find(modal_id).modal('hide') // #modal_id şeklinde olmalıdır.
          alert(response.data.msg)
        }).catch(function (e) {
            alert(I18n.t('generic_error'))
            console.log(e)
          })
    },
    notifyWhenPriceDown(modal_id, product) {
      var _this = this
      var product_id
      // liste ekranından mail listesine eklenince id gelmiyordu. bu sebeple ikinci parametre eklendiyse onu product id olarak kabul diyoruz.
      product_id = product == undefined ? _this.product.id : product.id
      securedAxiosInstance.post(apiNotifyWhenPriceDownPath(), {product_id: product_id, email: _this.notifyAlertEmail})
          .then(function (response) {
            $(_this.$el).find(modal_id).modal('hide') // #modal_id şeklinde olmalıdır.
            alert(response.data.msg)
          }).catch(function (e) {
        alert(I18n.t('generic_error'))
        console.log(e)
      })
    }
  },
  beforeMount: function() {
    var _this = this
    e2.warehouses.map( function(wh) { Vue.set(_this.whItems, wh.id, null) } )
  }
}

var addPromotionMixin = {
  data: function (){
    return {}
  },
  methods: {
    addPromotion: function (pu, event, pv) {
      var _this = this
      pu.qty = pu.qty || 1
      var items = []
      var itemObj = {pu_id: pu.id, qty: pu.qty}
      if (pv) itemObj.pv_id = pv.id // variant id
      if (!items.length) items = [itemObj] // sadece tek bir kalem sepete eklenecekse items içine atılıyor
      securedAxiosInstance.post(apiAddToPromotionPath(), {items: items})
        .then(function (response) {
          spinningRemove()
          var cartDetail = response.data
          _this.cartItems = cartDetail.cart_items
          _this.cart = cartDetail.cart
          pu.qty = ''
          _this.promotion = cartDetail.promotion //cartMixindeki promotion datasını güncelliyor
          _this.gift_products = jsonapi.parse(cartDetail.gift_products).data
          if (response.data.alerts.length > 0) {
            addToCartQtyLimitAlert(response.data.alerts)
          }
          setCartDetail(cartDetail)
        })
        .catch(function (e) {
          spinningRemove()
          if (e.response.status === 401 && b2bg) {
            alert(I18n.t('generic_login_required'))
          } else {
            alert(I18n.t('generic_error_cannot_be_added'))
          }
        })
    },
    applyPromotion: function () {
      var _this = this
      securedAxiosInstance.post(apiApplyPromotionPath())
        .then(function (response) {
          spinningRemove()
          var cartDetail = response.data
          _this.cartItems = cartDetail.cart_items
          _this.cart = cartDetail.cart
          _this.promotion = cartDetail.promotion //cartMixindeki promotion datasını güncelliyor
          if (response.data.alerts.length > 0) {
            addToCartQtyLimitAlert(response.data.alerts)
          }
          setCartDetail(cartDetail)
        })
        .catch(function (e) {
          spinningRemove()
          if (e.response.status === 401 && b2bg) {
            alert(I18n.t('generic_login_required'))
          } else {
            alert(I18n.t('generic_error_cannot_be_added'))
          }
        })
    }
  }
}

var b2bBalanceMixin = {
  data: function (){
    return {
      bakiye: null,
      bData: {},
      borc: 0,
      alacak: 0,
      baStr: '',
      value_date_debts: null,
    }
  },
  mounted: function (){
    if (dbVar.reset_pay_plans) {
      setGDataPaymentPlanId(e2.paymentPlans[0].id)
    }
    this.formatValues()
    if (dbVar.b2b_use_value_date) {
      this.showValueDateDebt()
    }
  },
  methods: {
    showValueDateDebt: function() {
      this.value_date_debts = getB2bUserData().b2b_user_value_date_data
      if (Object.keys(this.value_date_debts).length !== 0) {
        let keys = ['update_at','alert_open_payment','value_date_days']
        keys.forEach((key)=>{
          delete this.value_date_debts[key]
        })
        var companyCurrency = dbVar.dia_company_currency
        var vadesidolmamisteminattoplami = formatMoney(this.value_date_debts['vadesidolmamisteminattoplami'], companyCurrency)
        // Vadesi Geçmiş Vade Bilgileri Burada Ekleniyor.
        if (this.value_date_debts['vadesigecenvalor']) {
          vadesigecenvalortarih = new Date(this.value_date_debts['vadesigecenvalortarih']).toISOString().split('T')[0]
          this.value_date_debts['vadesigecenvalor'] = Math.ceil(this.value_date_debts['vadesigecenvalor'])
          this.value_date_debts['vadesigecentutar'] = formatMoney(this.value_date_debts['vadesigecentutar'], companyCurrency)
          this.value_date_debts['vadesigecenvadefarkitutari'] = formatMoney(this.value_date_debts['vadesigecenvadefarkitutari'], companyCurrency)
          this.value_date_debts['vadesidolmamisteminattoplami'] = vadesidolmamisteminattoplami
          this.value_date_debts['vadesigecenvalortarih'] = vadesigecenvalortarih.split('-').reverse().join('.')
        }
        // Vadesi Gelmeyen Vade Bilgileri Burada Ekleniyor.
        if (this.value_date_debts['vadesigelmeyenvadegun']) {
          vadesigelmeyenvadeguntarih = new Date(this.value_date_debts['vadesigelmeyenvadeguntarih']).toISOString()[0]
          this.value_date_debts['vadesigelmeyenvadegun'] = Math.ceil(Math.abs(this.value_date_debts['vadesigelmeyenvadegun']))
          this.value_date_debts['vadesigelmeyentutar'] = formatMoney(this.value_date_debts['vadesigelmeyentutar'], companyCurrency)
          this.value_date_debts['vadesidolmamisteminattoplami'] = vadesidolmamisteminattoplami
          this.value_date_debts['vadesigelmeyenvadeguntarih'] = vadesigelmeyenvadeguntarih.split('-').reverse().join('.')
        }
      }
    },
    updateBalance: function (){
      var _this = this
      securedAxiosInstance.post(apiB2bUpdateBalancePath(), {})
          .then(function (response) {
            if (response.data.code === 200) {
              setB2bUserData(response.data)
              _this.formatValues()
              return "Update successful"
            }
          }).catch(function (error) {
        return "failed with err => "+ error
      })
    },
    formatValues: function (){
      var _this = this
      var companyCurrency = dbVar.dia_company_currency
      var userCurrency = currenciesIdCode[getB2bUserData().currency_id]
      this.bData = getB2bUserData().balance_data
      var _bakiye = this.bData.bakiye
      this.bakiye = (_bakiye === 'undefined' ? 0 : _bakiye)
      this.baStr = this.bakiye < 0 ? '(B)' : '(A)'
      this.bakiye = Math.abs(this.bakiye)
      this.bakiye = formatMoney(this.bakiye, companyCurrency) + ' ' + this.baStr
      Object.keys(this.bData).map( function(k) { if (k.includes('borc_')) _this.borc += _this.bData[k] } )//borcları filtre edip topluyoruz borc_fatura borc_siparis
      Object.keys(this.bData).map( function(k) { if (k.includes('alacak_')) _this.alacak += _this.bData[k] } )//alacakları filtre edip topluyoruz alacak_fatura alacak_siparis
      this.borc = formatMoney( this.borc, companyCurrency )
      this.alacak = formatMoney( this.alacak, companyCurrency )
      Object.keys(this.bData).map( function(k) { //borc_fatura alacak_fatura gibi tl ye çeviriyoruz
        _this.bData[k] = formatMoney( _this.bData[k], ( k === 'bakiye_rd' ? userCurrency : companyCurrency) ) // bakiye_rd özel cari dövüzine göre gösteriyoruz
      })
    }
  }
}

var b2bLoginMixin = {
  mixins: [paymentPlanMixin],
  data: function data() {
    return {
      username: '',
      password: '',
      b2bUser: null, // sp login için
      b2bUsers: getSpB2bUsersData(), // sp login için
      spSignedIn: salespersonSignedIn(), // sp login için
      salesperson: false
    }
  },
  methods: {
    signin: function() {
      spinning()
      var _this = this
      var b2bUserId = $(".select2-plasiyer").val()
      securedAxiosInstance.post(apiB2bLoginPath(), { username: this.username, password: this.password, b2b_user_id: b2bUserId, spSignedIn: this.spSignedIn })
        .then(function (response) {
          spinningRemove()
          return _this.signinSuccessful(response)
        }).catch(function (error) {
          console.log(error)
          spinningRemove()
          return _this.signinFailed(error)
        })
    },
    signinSuccessful: function(response) {
      if (!response.data.csrf) {
        this.signinFailed(response)
        return
      }
      setB2bLogin(response.data)
      setCartDetail(response.data.cart_detail)
      setB2bc()
      console.log('b2bSignedIn')
      e2Alert.notice = I18n.t('generic_success')
      this.setCartPaymentPlan()

      var redirectedPath = langPath()
      if (localStorage.ref) redirectedPath = localStorage.ref
      if (redirectedPath.indexOf('/shopping/') !== -1) redirectedPath = cartPath()
      if (response.data.b2bUserData.forceResetPassword && !salespersonSignedIn()) redirectedPath = langPath() + 'b2b/account/info'
      // setTimeout(function(){ page.redirect(redirectedPath) }, 1000)
      setTimeout(function(){ window.location.href = redirectedPath }, 1000)
    },
    signinFailed: function(error) {
      console.log('signinFailed')
      $('.select2-plasiyer').select2('destroy')
      this.spSignedIn = false
      e2Alert.alert = error.response && error.response.data && error.response.data.error || ''
      deleteB2bUserData()
      return
    },
    spSignin: function () {
      var _this = this
      securedAxiosInstance.post(apiB2bSalespersonLoginPath(), { username: this.username, password: this.password })
        .then(function (response) {
          if (response.data.error) {
            _this.signinFailed(response.data.error)
          } else {
            setSpB2bUsersData(response.data.b2bUsers)
            _this.spSignedIn = true
            e2Alert.notice = I18n.t('generic_success')
            _this.b2bUsers = response.data.b2bUsers
            setSalespersonLogin(response.data.salespersonData)
            setTimeout(() => {_this.spSelect2()}, 500)
          }
        }).catch(function (error) {
        console.log(error)
        return _this.signinFailed(error)
      })
    },
    spSelect2: function () {
      $(".select2-plasiyer").select2({
        placeholder: 'Bayi Seçiniz',
        allowClear: true
      })
    }
  },
  mounted: function() {
    this.spSelect2()
  }
}

var b2cLoginMixin = {
  data: function() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signin: function() {
      var _this = this
      securedAxiosInstance.post(apiB2cLoginPath(), { email: this.email, password: this.password })
        .then(function (response) {
          return _this.signinSuccessful(response)
        }).catch(function (error) {
          return _this.signinFailed(error)
        })
    },
    signinSuccessful: function(response) {
      // console.log(response.data)
      if (!response.data.csrf) {
        this.signinFailed(response)
        return
      }
      setB2cLogin(response.data)
      setCartDetail(response.data.cart_detail)
      setB2bc()
      console.log('b2cSignedIn')
      e2Alert.notice = I18n.t('generic_success')
      setTimeout(function(){ page.redirect(getLastRedirect()) }, 1000)
    },
    signinFailed: function(error) {
      e2Alert.alert = '-'
      console.log('signinFailed')
      setTimeout(function(){ e2Alert.alert = error.response && error.response.data && error.response.data.error || '' }, 100)
      deleteB2cUserData()
    }
  }
}

var b2cSignUpMixin = {
  data: function() {
    return {
      jForm: null,
      user: {},
      addr: {},
      contractModalBody: ''
    }
  },
  methods: {
    signup: function() {
      if (this.jForm.valid()){
        this.setNewsletter()
        var _this = this
        spinning()
        securedAxiosInstance.post(apiB2cSignUpPath(), {user: this.user, address: this.addr})
          .then(function (response) {
            if (response.data.code === '200') {
              return _this.signupSuccessful(response)
            } else if(response.data.code === '301'){
              return _this.signupPending(response)
            }
          }).catch(function (error) {
            return _this.signupFailed(error)
          })
      } else {
        spinningRemove()
        return
      }
    },
    signupSuccessful: function(response) {
      // console.log(response.data)
      if (!response.data.csrf) {
        this.signupFailed(response)
        return
      }
      setB2cLogin(response.data)
      setCartDetail(response.data.cart_detail)
      console.log('b2cSignedUp')
      e2Alert.notice = _('Üyeliğiniz başarıyla oluşturulmuştur')
      setTimeout(function(){ page.redirect(getLastRedirect()) }, 2000)
      spinningRemove()
    },
    signupFailed: function(error) {
      e2Alert.alert = '-'
      console.log('signupFailed')
      setTimeout(function(){ e2Alert.alert = error.response && error.response.data && error.response.data.error || '' }, 100)
      deleteB2cUserData()
      spinningRemove()
      return
    },
    signupPending: function(response) {
      e2Alert.notice = response.data.message
      setTimeout(function(){ page.redirect(getLastRedirect()) }, 3000)
      spinningRemove()
    },
    setNewsletter: function(){
      if (typeof this.user.newsletter !== 'undefined') {
        this.user.newsletter_sms = this.user.newsletter
        this.user.newsletter_email = this.user.newsletter
        this.user.newsletter_phone = this.user.newsletter
      }
    },
    contractModal: function(concatType){
      this.contractModalBody = ''
      var _this = this
      securedAxiosInstance.get(contractPath()+'?key='+concatType)
        .then(function (response) {
          _this.contractModalBody = response.data
        })
        .catch(function (e) {
          console.log(e)
        })
    },
  },
  mounted: function() {
    $.extend( $.validator.messages, eval("jValidation_"+I18n.locale) )
    this.jForm = $(this.$el).find("#b2cSignUpForm")
    this.jForm.validate()
  }
}

var checkoutGuestMixin = {
  data: function (){
    return {
      jForm: null,
      user: {},
      contractModalBody: ''
    }
  },
  methods: {
    checkoutGuest: function() {
      if (this.jForm.valid()){
        var _this = this
        securedAxiosInstance.post(apiB2cCheckoutGuestPath(), {user: this.user})
            .then(function (response) {
              if (response.data.code === '200') {
                return _this.signupSuccessful(response)
              }
              else if (response.data.code === '301'){
                return _this.signupPending(response)
              }
            }).catch(function (error) {
          return _this.signupFailed(error)
        })
      } else {
        return
      }
    },
    signupSuccessful: function(response) {
      if (!response.data.csrf) {
        this.signupFailed(response)
        return
      }
      setB2cLogin(response.data)
      setCartDetail(response.data.cart_detail)
      setTimeout(function(){ page.redirect(cartPath()) }, 2000)
    },
    signupFailed: function(error) {
      e2Alert.alert = '-'
      console.log('signupFailed >> ', error)
      setTimeout(function(){ e2Alert.alert = error.response && error.response.data && error.response.data.error || '' }, 100)
      deleteB2cUserData()
      return
    },
    signupPending: function(response) {
      e2Alert.notice = response.data.message
      setTimeout(function(){ page.redirect(getLastRedirect()) }, 3000)
    },
    contractModal: function(concatType){
      this.contractModalBody = ''
      var _this = this
      securedAxiosInstance.get(contractPath()+'?key='+concatType)
          .then(function (response) {
            _this.contractModalBody = response.data
          })
          .catch(function (e) {
            console.log(e)
          })
    },
  },
  mounted: function() {
    $.extend( $.validator.messages, eval("jValidation_"+I18n.locale) )
    this.jForm = $(this.$el).find("#b2cGuestForm")
    this.jForm.validate()
  }
}

var cartMixin = {
  mixins: [paymentPlanMixin],
  data: function() {
    return {
      cartItems: rData.cart_detail.cart_items,
      cart: rData.cart_detail.cart,
      promotion: rData.cart_detail.promotion,
      gift_products: rData.cart_detail.gift_products ? jsonapi.parse(rData.cart_detail.gift_products).data : [],
      cartCurrCode: currenciesIdCode[rData.cart_detail.cart.currency_id],
      codes: rData.cart_detail.codes,
      freeShippingLimit: rData.free_shipping_limit,
      bodyExcelImport: '',
      excelResult: {added_item_count: 0, added_qty_count: 0, warnings: [], errors: []},
      note: '', //Hızlı Sipariş için sipariş notu
      total_with_salesperson_disc: 0
    }
  },
  mounted: function() {
    setCartDetail(rData.cart_detail)
    this.setCartPaymentPlan(true)
  },
  methods: {
    updateCartItemsQty: function(event, options) {
      var items = []
      for (var ci = 0; ci < this.cartItems.length; ci++) {
        var item = this.cartItems[ci]
        item.quantity = (parseFloat(item.quantity) || 1)
        if (item.quantity <= 0) item.quantity = 1
        items.push( {pu_id: item.product_unit_id, qty: item.quantity, variant_ids: item.variant_ids, wh_id: item.wh_id, dyn_fields: item.dyn_fields, five_dim: item.five_dim, note: item.note, status: item.status} )
      }
      if (items.length > 0) {
        if (event) {
          spinning(event.target.parentElement)
        }
        var _this = this
        return new Promise((resolve, reject) => {
          securedAxiosInstance.post(apiUpdateCartItemsPath(), {items: items, options: options})
            .then(function (response) {
              spinningRemove()
              var cartDetail = response.data
              _this.cartItems = cartDetail.cart_items
              _this.cart = cartDetail.cart
              _this.promotion = cartDetail.promotion
              _this.gift_products = cartDetail.gift_products ? jsonapi.parse(cartDetail.gift_products).data : []
              setCartDetail(cartDetail)
              if (response.data.alerts.length > 0) {
                e2Alert.alert = addToCartQtyLimitAlert(response.data.alerts, true)
              }
              if (cartDetail.cart.locked) alert(I18n.t('cart_in_process'))
              resolve(response)
            })
            .catch(function (e) {
              // if (e.response.status === 404) alert('404')
              console.log(e)
              throw e
            })
        })
      }
    },
    deleteCartItem: function(item, event) {
      event.preventDefault()
      spinning(event.target.parentElement)
      var _this = this
      var _item = {pu_id: item.product_unit_id, qty: 0, variant_ids: item.variant_ids, wh_id: item.wh_id, dyn_fields: item.dyn_fields, five_dim: item.five_dim, status: item.status}
      securedAxiosInstance.post(apiUpdateCartItemsPath(), { items: [_item] })
      .then(function (response) {
        spinningRemove()
        var cartDetail = response.data
        setCartDetail(cartDetail)
        _this.cartItems = cartDetail.cart_items
        _this.cart = cartDetail.cart
        _this.promotion = cartDetail.promotion
        _this.gift_products = cartDetail.gift_products ? jsonapi.parse(cartDetail.gift_products).data : []
        if (cartDetail.cart.locked) alert(I18n.t('cart_in_process'))
      })
      .catch(function (e) {
        spinningRemove()
        alert('Hata: Silinemedi!')
        console.log(e)
      })
    },
    submitExcelImport: function(event) {
      if (this.bodyExcelImport.length > 0) {
        if (event) {
          spinning(event.target.parentElement)
        }
        var _this = this
        securedAxiosInstance.post(apiAddFromExcelToCartPath(), {data_body: _this.bodyExcelImport})
        .then(function (response) {
          _this.excelResult = {added_item_count: 0, added_qty_count: 0, warnings: [], errors: []}
          spinningRemove()
          var cartDetail = response.data
          _this.cartItems = cartDetail.cart_items
          _this.cart = cartDetail.cart
          _this.codes = cartDetail.codes
          setCartDetail(cartDetail)
          if (cartDetail.cart.locked) alert(I18n.t('cart_in_process'))
          if (response.data.qty_limit_alerts.length > 0) {
            _this.excelResult.warnings = response.data.qty_limit_alerts
          }
          if (response.data.incorrect_barcodes.length > 0) {
            _this.excelResult.errors = response.data.incorrect_barcodes
          }
          _this.excelResult.added_item_count = response.data.added_item_count
          _this.excelResult.added_qty_count = response.data.added_qty_count
          _this.excelImportSuccess(_this)
        })
        .catch(function (e) {
          // if (e.response.status === 404) alert('404')
          console.log(e)
        })
      }
    },
    emptyCart: function(event) {
      if (confirm('Emin misiniz?')){
        spinning(event.target.parentElement)
        var _this = this
        securedAxiosInstance.post(apiEmptyCartPath())
          .then(function (response) {
          spinningRemove()
          var cartDetail = response.data
          _this.cartItems = cartDetail.cart_items
          _this.cart = cartDetail.cart
          setCartDetail(cartDetail)
          _this.promotion = cartDetail.promotion
          _this.gift_products = cartDetail.gift_products ? jsonapi.parse(cartDetail.gift_products).data : []
        })
          .catch(function (e) {
          console.log(e)
        })
      }
    },
    sendCart: function() {
      var _this = this
      let checkSendCart = new Promise(function(resolve, reject) {
          if (dbVar[b2bc + '_item_note']) {
            resolve(_this.updateCartItemsQty());
          } else {
            resolve(true)
          }

      });
      checkSendCart.then(() => {
        securedAxiosInstance.post(apiSendCartPath())
          .then(function (response) {
            if (response.data.code == '200') {
              // b2c login olmadan shopping/addresses sepeti sıfırladığı için login pathine git
              // TODO: Şimdilik böyle çözdük | v1 controllerlardan çözülecek
              if (b2cSignedIn() || b2bc !== 'b2c') {
                page(shopAddrPath())
              } else {
                page(b2cLoginPath())
              }
            } else if (response.data.code == '400') { // hata var uyarı basılıyor
              var cartDetail = response.data
              _this.cartItems = cartDetail.cart_items
              _this.cart = cartDetail.cart
              _this.codes = cartDetail.codes
              setCartDetail(cartDetail)
              if (response.data.alerts.length > 0) {
                e2Alert.alert = addToCartQtyLimitAlert(response.data.alerts, true)
              } else {
                e2Alert.alert = response.data.error_msg
              }
            }
          })
          .catch(function (e) {
            alert('Hata: !')
            console.log(e)
          })
      })
    },
    quickOrder: async function() {
      spinning()
      var _this = this
      let checkSendCart = new Promise(function(resolve, reject) {
        if (dbVar[b2bc + '_item_note']) {
          resolve(_this.updateCartItemsQty());
        } else {
          resolve(true)
        }

      });
      checkSendCart.then(() => {
        securedAxiosInstance.post(apiQuickOrderPath(), {note: _this.note})
          .then(function (res) {
            spinningRemove()
            if (res.data.code === '400') {//hata var uyarı basılıyor
              if (res.data.alerts.length > 0) {
                e2Alert.alert = addToCartQtyLimitAlert(res.data.alerts, true)
              } else {
                e2Alert.alert = res.data.error_msg
              }
            } else if (res.data.code === '200') {
              setCartDetail(emptyCartData)
              page.redirect(orderCompletePath() + '?order_no=' + res.data.order_no)
            }
          }).catch(function (e) {
          spinningRemove()
          alert('Hata: !')
          console.log(e)
        })
      })
    },
    dynFields2Str: function(item, sep) {
      sep = sep || ', '
      var resultArr = []
      if (item.dyn_fields) {
        Object.keys(item.dyn_fields).forEach(function(diaCol) {
          var df = e2.dynamic_fields.scf_siparis_kalemi.find(function(df) {return df.col_name === diaCol})
          var itemVal = item.dyn_fields[diaCol] // sepet kaleminin dinamik alan değerleri {"1": ["Seçilen Değer"]
          if (df && itemVal) {
            if (df._type === 'mcombo') {
              itemVal.forEach(function(_item_val) {
                resultArr.push(df.parameters.wp_mcombo_deger.find(function(cVal) {return cVal.kaydedilecekdeger === _item_val}).gorunendeger)
              })
            } else if (df._type === 'combo') {
              resultArr.push(df.parameters.wp_combo_deger.find(function(cVal) {return cVal.kaydedilecekdeger === itemVal}).gorunendeger)
            } else {
              resultArr.push(itemVal)
            }
          }
        })
      }
      return resultArr.join(sep)
    },
    whName: function(item) {
      var wh = e2.warehouses.find(function(wh) {return wh.id === item.wh_id})
      return wh ? wh.name : ''
    },
    excelImportSuccess: function(_this) {
      setTimeout(function(){ $(_this.$el).find("#excelImport").modal('hide') }, 2500)
    },
    set_salesperson_disc_to_item: function(item) {
      let _this = this
      securedAxiosInstance.post(apiUpdateCartItemWithSpDiscPath(), { item: item })
        .then(function (response) {
          spinningRemove()
          if (response.data.code == '400') {
            e2Alert.alert = response.data.error_msg
          } else {
            var cartDetail = response.data
            setCartDetail(cartDetail)
            _this.cartItems = cartDetail.cart_items
            _this.cart = cartDetail.cart
            _this.promotion = cartDetail.promotion
            _this.gift_products = cartDetail.gift_products ? jsonapi.parse(cartDetail.gift_products).data : []
          }
        })
    }
  },
}

var shopAddrMixin = {
  data: function() {
    return {
      b2b_ship_addrs: rData.b2b_ship_addrs,
      b2b_bill_addr: rData.b2b_bill_addr,
      b2c_addrs: rData.b2c_addrs,
      cart: rData.cart,
      freeShippingLimit: rData.free_shipping_limit,
      cartCurrCode: null,//created ta doluyor
      addr: emptyAddrData,
      selectedBillAddrId: null,//(rData.b2b_ship_addrs[0] ? rData.b2b_ship_addrs[0].id : null)
      selectedShipAddrId: null,//sadece b2c için
      diffBillAddr: false//sadece b2c için fatura adresi farklı olsun
    }
  },
  beforeCreate: function() {
    if (b2bc === 'b2c'){
      this.selectedBillAddrId = (rData.b2c_addrs[0] ? rData.b2c_addrs[0].id : null)
      this.selectedShipAddrId = (rData.b2c_addrs[0] ? rData.b2c_addrs[0].id : null)
    } else if (b2bc === 'b2b'){
      this.selectedShipAddrId = (rData.b2b_ship_addrs[0] ? rData.b2b_ship_addrs[0].id : null)
    }
  },
  methods: {
    editAddr: function(addr) {
      //console.log(addr)
      this.addr = JSON.parse(JSON.stringify(addr))//clone
      this.$refs.modalAddr.setDistrict(addr)//child componentin <modal-addr ref="modalAddr" fonksiyonunu çağırıyoruz
      if (this.cargoMixin) { this.shipAddrChanged() }//eğer kargo mixin varsa kargo.shipAddrChanged tetikliyoruz
    },
    sendAddr: function() {
      if ( $(this.$el).find("#addrModalForm").valid() ){
        spinning( $(this.$el).find("#addrModalForm")[0] )
        var _this = this
        securedAxiosInstance.post(apiAddAddrPath(), {address: this.addr})
          .then(function (response) {
            // console.log(response.data)
            if (b2bc === 'b2c'){
              _this.b2c_addrs = response.data //tüm adresleri setliyoruz
              if (_this.b2c_addrs.length > 0) _this.selectedShipAddrId = _this.b2c_addrs[0].id
            } else if (b2bc === 'b2b'){
              _this.b2b_ship_addrs = response.data //tüm ship adresleri setliyoruz
            }
            if (_this.cargoMixin) { _this.shipAddrChanged() }//eğer kargo mixin varsa kargo.shipAddrChanged tetikliyoruz
            spinningRemove()
          })
          .catch(function (e) {
            spinningRemove()
            alert(I18n.t('generic_error_cannot_be_added'))
            console.log(e)
          })
        $(this.$el).find("#addrModal").modal('hide')
      }
    },
    delAddr: function(addr, e) {
      if (confirm(I18n.t('generic_are_you_sure'))) {
        spinning( e.target )
        var _this = this
        securedAxiosInstance.delete(apiDelAddrPath(addr.id))
          .then(function (response) {
            // console.log(response.data)
            if (b2bc == 'b2c'){
              _this.b2c_addrs = response.data//tüm  adresleri setliyoruz
              _this.selectedBillAddrId = (rData.b2c_addrs[0] ? rData.b2c_addrs[0].id : null)
              _this.selectedShipAddrId = (rData.b2c_addrs[0] ? rData.b2c_addrs[0].id : null)
            } else if (b2bc == 'b2b'){
              _this.b2b_ship_addrs = response.data //tüm ship adresleri setliyoruz
              _this.selectedShipAddrId = (_this.b2b_ship_addrs[0] ? _this.b2b_ship_addrs[0].id : null)
            }
            if (_this.cargoMixin) { _this.shipAddrChanged() }//eğer kargo mixin varsa kargo.shipAddrChanged tetikliyoruz
            spinningRemove()
          })
          .catch(function (e) {
          spinningRemove()
          alert('Hata: Silinemedi!')
          console.log(e)
        })
      }
      e.preventDefault()
    },
    sendDataToCart: function() {
      var _this = this
      var ship_addr = {}
      var bill_addr = {}
      var cargo_id = null
      if (b2bc === 'b2c'){
        if ( (!this.diffBillAddr && this.selectedShipAddrId) || this.diffBillAddr && this.selectedShipAddrId && this.selectedBillAddrId ) {
          if (!this.selCargoFirmId) return e2Alert.alert = I18n.t('order_validate_shipping_method')
          ship_addr = getObjFromObjs(this.b2c_addrs, this.selectedShipAddrId)
          if (this.diffBillAddr){//fatura adresi farklıysa
            bill_addr = getObjFromObjs(this.b2c_addrs, this.selectedBillAddrId)
          } else {
            bill_addr = ship_addr
          }
        } else {
          if (this.b2c_addrs.length === 0) this.$refs.addB2cAddrBut.click()
          return e2Alert.alert = I18n.t('order_validate_shipping_address')
        }
        cargo_id = this.selCargoFirmId
      } else if (b2bc === 'b2b'){
        // if (!this.selCargoFirmId) return e2Alert.alert = I18n.t('order_validate_shipping_method')
        if (this.selectedShipAddrId) {
          ship_addr = getObjFromObjs(this.b2b_ship_addrs, this.selectedShipAddrId)
          bill_addr = this.b2b_bill_addr
        } else {
          return e2Alert.alert = I18n.t('order_validate_shipping_address')
        }
        cargo_id = this.selCargoFirmId
      }
      securedAxiosInstance.post(apiSendAddrToCartPath(), {bill_addr: bill_addr, ship_addr: ship_addr, cargo_id: cargo_id})
        .then(function (response) {
          if (response.data.code === '200') {
            page(shopPayPath())
          } else {
            return e2Alert.alert = response.data.error_msg
          }
        })
        .catch(function (e) {
          alert(I18n.t('generic_error_cannot_be_added'))
          console.log(e)
        })
    },
    checkAddr: function(addr) { //boşta kullanılmıyor adreslerin içindeki bilgileri check etmek için
      if ( isBlank(addr.name) || isBlank(addr.city_id) || isBlank(addr.district_id) || isBlank(addr.address1) || isBlank(addr.gsm) ){
        return false
      } else {
        return true
      }
    },
  },
  created: function() {
    if (this.cart) {this.cartCurrCode = currenciesIdCode[this.cart.currency_id]}//burası hesabım adres editlemek için yapıldı, o bölümde cart gelmiyor
  },
  mounted: function() {
    $.extend( $.validator.messages, eval("jValidation_"+I18n.locale) )
    $(this.$el).find("#addrModalForm").validate()
    if (this.b2c_addrs && this.b2c_addrs.length > 0) this.selectedShipAddrId = this.b2c_addrs[0].id
  }
}

var shopCargoMixin = {
  data: function data() {
    return {
      cargoMixin: true,
      b2b_targetCurrCode: null,
      b2c_targetCurrCode: dbVar.b2c_order_currency,
      cargo_currency_code: '',
      cargo_price: 0,
      ship_addr: [],
      cargoFirms: [],//kargo firmaları teslim adresi city_id seçilince gelecek
      selCargoFirmId: null//seçili kargo firması
    }
  },
  methods: {
    shipAddrChanged: function() {
      this.setShipAddr()
      var _this = this
      // normalde shipping adresi ödeme sayfası adresler sayfasından seçiliyor fakat müşteri sadece fatura adresi gözükmesini istediğinden
      // eğer parametre true ise aşağıdaki iki satır ile fatura adresini set ediyoruz.
      var ship_addr = b2bc == 'b2b' && dbVar.b2b_use_only_bill_address_at_order ? this.b2b_bill_addr : getObjFromObjs(this.ship_addr, this.selectedShipAddrId)
      if (b2bc == 'b2b' && dbVar.b2b_use_only_bill_address_at_order) this.selectedShipAddrId = this.b2b_bill_addr.id
      if (ship_addr) {
        // securedAxiosInstance.post(apiCargoCalculatePricePath(), {cart_id: this.cart.id, city_id: ship_addr.city_id})
        securedAxiosInstance.post(apiCargoCalculatePricePath(), {city_id: ship_addr.city_id})
          .then(function (response) {
            _this.cargoFirms = response.data.cargo_firms
            let cargo = null
            if (_this.cargoFirms.length > 0) {
              cargo = _this.cargoFirms[0]
              if (_this.cargoFirms.some(c => c.id == _this.selCargoFirmId)) {
                cargo = getObjFromObjs(_this.cargoFirms, _this.selCargoFirmId)
              }
              _this.cargoFirmChanged(cargo)
            }
          })
          .catch(function (e) {
            alert(I18n.t('generic_error_cannot_be_added'))
            console.log(e)
          })
        }
    },
    cargoFirmChanged: function(cargoFirm) {
      this.selCargoFirmId = cargoFirm.id
      this.cart.shipping_price = cargoFirm.price
      this.freeShippingLimit = cargoFirm.free_shipping_rate
      this.cargo_currency_code = currenciesIdCode[cargoFirm.currency_id]
      let target_curr = b2bc === 'b2c' ? this.b2c_targetCurrCode : this.b2b_targetCurrCode
      this.cargo_price = formatMoney(cargoFirm.price, currenciesIdCode[cargoFirm.currency_id], target_curr,{onlyPrice: true})
    },
    setShipAddr: function() {
      this.ship_addr = b2bc === 'b2c' ? this.b2c_addrs : this.b2b_ship_addrs
    }
  },
  mounted: function() {
    this.setShipAddr()
    if (this.ship_addr.length > 0) {
      this.shipAddrChanged()
    }
    if (b2bc === 'b2b') {
      if (dbVar.b2b_order_currency == 'cari_dovizi' && getB2bUserData()) {
        this.b2b_targetCurrCode = currenciesIdCode[getB2bUserData().currency_id]
      } else {
        this.b2b_targetCurrCode = dbVar.b2b_order_currency
      }
    } else {
      this.b2c_targetCurrCode = dbVar.b2c_order_currency
    }
  },
}

var shopPayMixin = {
  data: function data() {
    return {
      b2b_user: rData.b2b_user,
      b2c_user: rData.b2c_user,
      b2b_targetCurrCode: null,
      b2c_targetCurrCode: dbVar.b2c_order_currency,
      cart: rData.cart,
      cartCurrCode: currenciesIdCode[rData.cart.currency_id],
      payType: null,
      showCCInstal: true,
      runAcObj: {},//b2b

      ccForm: null,
      bin_list: rData.bin_list,
      ccObj: {},
      virtualPos: rData.virtual_pos,
      bankAccounts: rData.bank_accounts,
      payAtDoorCargoFirms: rData.pay_at_door_cargo_firms,
      note: '',

      selectedInst: null,//seçili taksit
      selectedVpos: {},//seçili vpos
      enableChooseInst: false,//taksitler seçilebilir mi? Kart numarasının ilk altı hanesi girilmişse
      selectedCCGroup: null,//karta ait taksitler garanti bankası 1-3-6 taksit grubu
      selectedBank: null,//banka havale
      payAtDoorCargoPrice: 0,
      PADCargoFirm: null,//adreslerde seçilen kargo kapıda ödeme yapabiliyor mu?
      PADPaymentType: 'p',//kapıda ödeme Nakit mi CC mi c:cc, p:prepay
      secureType: '3d',
      payPlanName: '',
      payPlanPayType: null,

      contract: {
        termsOfSale: false,
        preliminary: false
      },
      contractModalBody: '',
    }
  },
  methods: {
    //Ödeme Tiplerine Göre Kısıtlamayı Sağlıyor.
    // PAY_TYPES GLOBAL değişkeninde payPlanPayTypelar orda (PaymentPlan::PAY_TYPES)
    checkPaymentTypes(field) {
      const shouldCheckOpenPayment = (getB2bUserData().b2b_user_value_date_data || {}).value_date_days !== 0
      const valueVarCheck = dbVar.b2b_use_value_date ? shouldCheckOpenPayment : true;
      let resultOpenAccount = null;
      let resultPayBankTransfer = null;
      let payment_privileges = getB2bUserData().payment_privileges
      if(dbVar.b2b_use_value_date ){
        resultOpenAccount = valueVarCheck ?  true : !dbVar.b2b_value_date_payment_types.includes('open_payment')
        resultPayBankTransfer = valueVarCheck ?  true : !dbVar.b2b_value_date_payment_types.includes('pay_bank_transfer')
        if (field === 'open_account' && resultOpenAccount) {
          return resultOpenAccount
        }else if (field === 'pay_bank_transfer' && resultPayBankTransfer) {
          return resultPayBankTransfer
        }else if (field === 'credit_card') {
          return true
        }
      } else if (this.payPlanPayType) {
        if (field === 'open_account' && (this.payPlanPayType === 1 || (this.payPlanPayType == null && !(payment_privileges.includes('credit_card') && payment_privileges.length === 1) ))) {
          return true
        }
        if (field === 'pay_bank_transfer' && (!this.payPlanPayType || this.payPlanPayType === 5 )) {
          return this.bankAccounts.length
        }
        if (field === 'credit_card' && ([2,3,4].includes(this.payPlanPayType) || !this.payPlanPayType)) {
          return this.virtualPos.length
        }
      }
      else {
        return this.paymentPrivileges(field)
      }
    },
    paymentPrivileges(field) {
      var paymentPrivileges = getB2bUserData().payment_privileges
      if (paymentPrivileges.length >= 1) {
        if (field === 'credit_card' && this.checkPaymentMethod('credit_card')) {
          return this.checkPaymentMethod('credit_card')
        }
        if (field === 'pay_bank_transfer' && this.checkPaymentMethod('pay_bank_transfer')) {
          return this.checkPaymentMethod('pay_bank_transfer')
        }
        if (field === 'open_account' && this.checkPaymentMethod('open_account')) {
          return this.checkPaymentMethod('open_account')
        }
        if (paymentPrivileges.length < 1) {
          return true
        }
        return false
      }
      return true
    },
    // Ödeme Yetkileri Bölümü
    checkPaymentMethod(field) {
      return getB2bUserData().payment_privileges.includes(field)
    },

    instPaymentControl: function (inst, ccNumberLength) {
      if (ccNumberLength > 6 && (inst.min_instal_amount > this.cart.total_price)) {
        return 'disabled';
      } else if (
          dbVar.b2b_use_value_date === true &&
          inst.value_date_days > rData.b2b_user.b2b_user_value_date_data.value_date_days
      ) {
        return 'disabled';
      } else if (this.selectedInst === inst.id) {
        return 'border border-success mb-0';
      } else {
        return '';
      }
    },
    // B2B Serbest Ödeme
    payRunAcSubmitCheck: function(e){
      spinning()
      var _this = this
      if (b2bc === 'b2b' && !this.contract.termsOfSale){
        spinningRemove()
        return e2Alert.alert = _('Sözleşmeler Kabul Edilmelidir!')
      } else {
        securedAxiosInstance.post(apiShoppingPayPath('pay_b2b_run_ac'), {password: _this.runAcObj.password, note: this.note})//b2bc/orders_controller/pay_b2b_run_ac
          .then(function (response) {
            spinningRemove()
            if (response.data.code === '401'){
              e2Alert.alert = 'Şifre Hatalı'
            } else if (response.data.code === '200') {
              setCartDetail(emptyCartData)
              page.redirect(orderCompletePath()+'?order_no='+response.data.order_no)
            } else {
              e2Alert.alert = response.data.error_msg
            }
          })
          .catch(function (e) {
            spinningRemove()
            alert('Hata: !')
            console.log(e)
          })
      }
      return false
    },
    // Kredi Kartı Ödeme
    payCCSubmitCheck: function(e){//b2c ve b2b ortak
      if ( this.ccForm.valid() && this.selectedInst ){
        spinning( e.target.parentElement )
        var _this = this
        var payPath = ''
        if (b2bc === 'b2c'){
          payPath = apiShoppingPayPath('pay_b2c_cc')
        } else if (b2bc === 'b2b'){
          payPath = apiShoppingPayPath('pay_b2b_cc')
        }
        // $(_this.$el).find("#ccPayModal").modal()
        // this.postToCcIframe('ccPayModalIframe', payPath, {cc_data: this.ccObj, instal_id: this.selectedInst, secure_type: this.secureType, note: this.note})
        securedAxiosInstance.post(payPath, {cc_data: this.ccObj, instal_id: this.selectedInst, secure_type: this.secureType, note: this.note})
          .then(function (response) {
          spinningRemove()
          if (response.data.code === '200') {
            page.redirect( orderCompletePath()+'?cc_payment_id='+response.data.cc_payment_id )
          } else if (response.data.code === '201' || response.data.code === '204') {//3d sonucu dönen html sayfa 204: URL redirect MOKAPos
            $(_this.$el).find("#ccPayModal").modal({backdrop: 'static', keyboard: false})
            var iframe = $(_this.$el).find("#ccPayModalIframe")[0] // ilk eleman ([0]) demek normal js elemente çeviriyor
            if (response.data.code === '201') { // GENEL html replace
              iframe = iframe.contentWindow.document.open("text/html", "replace")
              iframe.write(response.data.html_3d)
              iframe.close()
            } else if (response.data.code === '204') {// MOKA URL redirect
              iframe.src = response.data.redirect_url
            }
            setTimeout(function(){ $(_this.$el).find(".modal-close-button").show() }, 3000)
          } else {
            e2Alert.alert = response.data.error_msg
          }
          // console.log('Eklendi!')
        })
          .catch(function (e) {
          spinningRemove()
          alert('Hata: !')
          console.log(e)
        })
      } else if (this.ccForm.valid() && !this.selectedInst){
        e2Alert.alert = I18n.t('payment_choose_install')
      }
      return false
    },



    // Havale ile ödeme
    payBankTransSubmitCheck: function(e){
      if (!this.selectedBank) return e2Alert.alert = 'Lütfen bir banka hesabı seçiniz!'
      spinning( e.target )
      var _this = this
      securedAxiosInstance.post(apiShoppingPayPath('pay_bank_transfer'), {selected_bank_id: this.selectedBank, note: this.note})
        .then(function (response) {
        spinningRemove()
        if (response.data.code === '200') {
          setCartDetail(emptyCartData)
          page.redirect(orderCompletePath()+'?order_no='+response.data.order_no)
        } else {
          e2Alert.alert = response.data.error_msg
        }
        // console.log('Eklendi!')
      })
        .catch(function (e) {
        spinningRemove()
        alert('Hata: !')
        console.log(e)
      })
    },
    // Kapıda Ödeme
    payAtDoorSubmitCheck: function(e){
      if (!this.PADCargoFirm) return e2Alert.alert = 'Lütfen bir kapıda ödemesi firması seçiniz!'
      spinning( e.target )
      var _this = this
      securedAxiosInstance.post(apiShoppingPayPath('pay_at_door'), {note: this.note})
        .then(function (response) {
          spinningRemove()
          if (response.data.code === '200') {
            setCartDetail(emptyCartData)
            page.redirect(orderCompletePath()+'?order_no='+response.data.order_no)
          } else {
            e2Alert.alert = response.data.error_msg
          }
          // console.log('Eklendi!')
        })
        .catch(function (e) {
          spinningRemove()
          alert('Hata: !')
          console.log(e)
        })
    },
    // setPayMethod: function(payType) {
    //   this.paymentType = payType
    //   payType === 'c' ? this.showCCInstal = true : this.showCCInstal = false
    //   if (payType === 'b' && this.bankAccounts.length === 1) this.selectedBank = this.bankAccounts[0].id
    //   // payType === 'd' Eğer d yani kapıda ödemeyse watch: ile yeni ve eski değer izleniyor, kapıda ödeme seçilip/seçilmediğinde backende veri gidiyor hesapnlanması için
    // },
    setPad: function(reset){
      if (this.PADCargoFirm) {
        var _this = this
        var params = reset ? {reset: true} : {pad_type: this.PADPaymentType}
        spinning( this.$refs.payPayBut )
        spinning( this.$refs.orderSum )
        securedAxiosInstance.post(apiCargoCalcPayAtDoorPath(), params)
          .then(function (response) {
            spinningRemove()
             _this.cart = response.data.cart
          })
          .catch(function (e) {
            spinningRemove()
            alert('Hata: !')
            console.log(e)
          })
      }
    },
    setPaymentTypeDisc: function(_type){
      if (_type) {
        var _this = this
        var params = _type === 'reset' ? {reset: true} : {payment_type: _type}
        spinning( this.$refs.payPayBut )
        spinning( this.$refs.orderSum )
        securedAxiosInstance.post(apiPaymentCalcDiscPath(), params)
          .then(function (response) {
            spinningRemove()
            _this.cart = response.data.cart
          })
          .catch(function (e) {
            spinningRemove()
            alert('Hata: !')
            console.log(e)
          })
      }
    },
    clickIns: function(vPos, inst){
      if (this.enableChooseInst){
        this.selectedInst = inst.id
        this.selectedVpos = this.virtualPos.filter(function (obj) {return obj === vPos})[0]
        this.set3dSecure(this.selectedVpos)
      }
    },
    set3dSecure: function(vpos){
      if (vpos.secure_3d) {
        this.secureType = '3d'
      } else if (vpos.secure_normal) {
        this.secureType = 'normal'
      } else {
        this.secureType = '3d'
      }
    },
    limitNote: function(){
      this.note = this.note.substring(0, 127)
    },
    payPay: function(e){
      // console.log(this.paymentType)
      if (b2bc === 'b2c' && (!this.contract.termsOfSale || !this.contract.preliminary)) { return e2Alert.alert = _('Sözleşmeler Kabul Edilmelidir!') }
      if (b2bc === 'b2b' && !this.contract.termsOfSale) { return e2Alert.alert = _('Sözleşmeler Kabul Edilmelidir!') }
      if (this.payType === 'b') {
        this.$refs.payBankTransBut.click()
      } else if (this.payType === 'c') {
        this.payCCSubmitCheck(e)
      } else if (this.payType === 'r') {
        this.$refs.payRunAcBut.click()
      } else if (this.payType === 'w') {
        this.$refs.payIwalletBut.click()
      } else if (this.payType === 'd') {
        this.$refs.payAtDoorBut.click()
      }
    },
    contractModal: function(concatType){
      this.contractModalBody = ''
      var _this = this
      securedAxiosInstance.get(contractPath()+'?key='+concatType+'&payment_type='+_this.payType)
        .then(function (response) {
          _this.contractModalBody = response.data
        })
        .catch(function (e) {
          console.log(e)
        })
    }
  },
  mounted: function() {
    var _this = this

    $.extend( $.validator.messages, eval("jValidation_"+I18n.locale) )
    this.ccForm = $(this.$el).find("#pay-credit-card-form")
    this.ccForm.validate({messages: {cc_number: I18n.t('payment_invalid_cc_number')}} )
    setTimeout(() => {
      var firstPayMethod = $(this.$el).find("#payTypes .list-group-item:first-child")
      if(firstPayMethod.length > 0){ // Eğer bayinin bu ödeme yöntemi kısıtlandıysa kontrol sağlıyoruz
        firstPayMethod[0].click()
        this.$nextTick(function (){ firstPayMethod.addClass('active') })
      }
    }, 50)
    this.PADCargoFirm = this.payAtDoorCargoFirms.filter(function (cargo) { return cargo.id === _this.cart.cargo_firm_id })
    if (this.PADCargoFirm) this.PADCargoFirm = this.PADCargoFirm[0]
    var paymentPlan = this.cart.payment_plan_id ? e2.paymentPlans.find(pp => pp.id === this.cart.payment_plan_id) : null
    this.payPlanName = paymentPlan ? paymentPlan.name : ''
    this.payPlanPayType = paymentPlan ? paymentPlan.pay_type : null
    if (dbVar.b2b_order_currency == 'cari_dovizi' && b2bc === 'b2b') {
      this.b2b_targetCurrCode = currenciesIdCode[getB2bUserData().currency_id]
    } else {
      this.b2b_targetCurrCode = dbVar.b2b_order_currency
    }
  },
  watch: {
    payType: function (newPayType, oldPayType) {
      if (newPayType === 'c') {
        this.showCCInstal = true
        this.setPaymentTypeDisc('c')
      } else { this.showCCInstal = false }
      if (newPayType === 'b') {
        if (this.bankAccounts.length === 1) this.selectedBank = this.bankAccounts[0].id
        this.setPaymentTypeDisc('b')
      }
      if (newPayType === 'd') {
        this.setPad(false)
      } else if (oldPayType === 'd') {
        this.setPad(true)
      }
      if (newPayType === 'r' || newPayType === 'd') this.setPaymentTypeDisc('reset')
    }
  }
}
var shopPayIwalletMixin = {
  data: function data() {
    return {
      jqIwalletModal: null,
      iwalletCardNo: '',
      payData: {}
    }
  },
  methods: {
    payIwallet1: function(e){//b2c ve b2b ortak
      e2Alert.alert = null
      if ( this.iwalletCardNo.length === 7 || this.iwalletCardNo.length >= 16 ){
        spinning( e.target )
        var _this = this
        securedAxiosInstance.post(apiShoppingPayPath('iwallet_pay1'), {cc_no: this.iwalletCardNo})
          .then(function (response) {
            spinningRemove()
            var rData = response.data
            if (rData.code === '201') {
              setCartDetail(emptyCartData)
              setTimeout(function(){ page.redirect(orderCompletePath()+'?order_no='+response.data.order_no) }, 500)
            } else if (rData.code === '200') {
              _this.payData = {oid: rData.oid, valid_type: rData.valid_type, msg: rData.msg, cc_number: _this.iwalletCardNo}
              _this.jqIwalletModal.modal({backdrop: 'static', keyboard: false})
              setTimeout(function(){ _this.jqIwalletModal.find(".modal-close-button").show() }, 3000)
            } else {
              e2Alert.alert = response.data.error_msg
            }
          })
          .catch(function (e) {
            spinningRemove()
            alert('Hata: !')
            console.log(e)
          })
      } else {
        e2Alert.alert = I18n.t('payment_iwallet_invalid_cc_number')
      }
      return false
    },
    payIwallet2: function(e){//b2c ve b2b ortak
      e2Alert.alert = null
      if ( this.iwalletCardNo.length >= 16 ){
        spinning( e.target )
        var _this = this
        securedAxiosInstance.post( apiShoppingPayPath('iwallet_pay2'), this.payData )
          .then(function (response) {
            spinningRemove()
            var rData = response.data
            if (rData.code === '200') {
              setCartDetail(emptyCartData)
              _this.jqIwalletModal.modal('hide')
              setTimeout(function(){ page.redirect(orderCompletePath()+'?order_no='+response.data.order_no) }, 500)
            } else {
              e2Alert.alert = response.data.error_msg
            }
            _this.jqIwalletModal.modal('hide')
          })
          .catch(function (e) {
            spinningRemove()
            alert('Hata: !')
            console.log(e)
            _this.jqIwalletModal.modal('hide')
          })
      }
      return false
    }
  },
  mounted: function() {
    this.jqIwalletModal = $(this.$el).find("#iwalletModal")
  }
}
var binCheckMixin = {
  data: function data() {
    return {
      ccBusiness: false,
      ccNumberLength: 0
    }
  },
  methods: {
    binCheck: function(){
      var ccNumber = this.ccObj.cc_number
      var vPosGroups = this.virtualPos.map(function (v) { return v.pos_group })
      this.ccNumberLength = this.ccObj.cc_number.length
      if (ccNumber.length >= 6) {
        var ccGroup = this.bin_list[ccNumber.substring(0,6)]
        if (ccGroup){
          ccGroup = this.bin_list[ccNumber.substring(0,6)]["bank"]
          this.ccBusiness = this.bin_list[ccNumber.substring(0,6)]["business"]
        }

        if (vPosGroups.length === 1){
          this.selectedCCGroup = vPosGroups[0]
        } else if (ccGroup && vPosGroups.indexOf(ccGroup) !== -1){
          this.selectedCCGroup = ccGroup
        } else {
          this.selectedCCGroup = 'other'
        }
        this.enableChooseInst = true
      } else {
        this.enableChooseInst = false
        this.selectedInst = null
        this.selectedCCGroup = null
        // this.secureType = null
      }
    }
  }
}

var shopOrderCompleteMixin = {
  data: function() {
    return {
      order_no: rData.order_no
    }
  }
}


var addrCityMixin = {
  methods: {
    cityChanged: function cityChanged() {
      var _this = this
      this.addr.city_name = getAttrFromObj(cities, this.addr.city_id, 'name')
      var plateCode = getAttrFromObj(cities, this.addr.city_id, 'plate_code')
      plainAxiosInstance.get("/json/districts/25"+plateCode+".json")
        .then(function (response) {
          // console.log(response.data)
          _this.districts = response.data
        })
        .catch(function (e) {
          alert('Hata: Yüklenemedi!')
          console.log(e)
        })
    },
    districtChanged: function districtChanged() {
      var _this = this
      // console.log(this.districts)
      this.addr.district_name = getAttrFromObj(this.districts, this.addr.district_id, 'name')
    },
    setDistrict: function setDistrict(addr) {
      var _this = this
      var plateCode = getAttrFromObj(cities, addr.city_id, 'plate_code')
      if (plateCode){
        plainAxiosInstance.get("/json/districts/25"+plateCode+".json")
          .then(function (response) {
            _this.districts = response.data
            if (!dbVar.use_text_district_name_in_address) _this.addr.district_name = getAttrFromObj(_this.districts, addr.district_id, 'name')
          })
          .catch(function (e) {
            alert('Hata: Yüklenemedi!')
            console.log(e)
          })
      }
    }
  },
  data: function data() {
    return {
      districts: []
    }
  }
}

var e2FormMixin = {
  data: function data() {
    return {
      jForm: null,
      codeImagePath: apiCodeImagePath()
    }
  },
  methods: {
    refreshCodeImage: function refreshCodeImage(e) {
      this.codeImagePath = apiCodeImagePath()+'?rand='+Math.random()
      e.preventDefault()
    },
    formSubmit: function formSubmit(e){
      if (this.jForm.valid()){
        spinning(e.target)
        var _this = this
        securedAxiosInstance.post(this.formPath, { form_data: serializeHash(this.jForm.serializeArray()) })
          .then(function (response) {
            console.log(response.data)
            if (response.data.code == '200'){
              e2Alert.notice = _this.msgSuccess
              _this.jForm[0].reset()
            } else {
              e2Alert.alert = response.data.error_msg
            }
            spinningRemove()
            _this.refreshCodeImage(e)
            return
          }).catch(function (error) {
            spinningRemove()
            e2Alert.alert = 'Hata'
            _this.refreshCodeImage(e)
            return
          })
      } else {
        return
      }
    }
  },
  mounted: function mounted() {
    $.extend( $.validator.messages, eval("jValidation_"+I18n.locale) )
    this.jForm = $(this.$el).find("form")
    this.jForm.validate()
  }
}

var productListFilterMixin = {
  mixins: [paymentPlanMixin],
  data: function() {
    return {
      brandList: rData.filters.brands,
      brandListSortType: 'az',
      codesListSortType: {},//mounted da doluyor
      catList: rData.filters.sub_categories,
      codeList: rData.filters.codes,
      attrList: rData.filters.attrs,
      variantList: rData.filters.variants,
      query: '',
      min_price: '',
      max_price: '',
      filterData: queryHash(),
      removableFilter: false,
      showMobileFilter: false,
      category: rData.category,//sayfa bir kategori sayfasıysa dolu geliyor
      brand: rData.brand,//sayfa bir marka sayfasıysa dolu geliyor
      showOnlyInStock: queryHash().stock === 'true' //sadece stoktakileri göster wacth ile kontrol ediliyor
    }
  },
  methods: {
    brandName: function(id) {
      return getAttrFromObj(brands, id, 'name')
    },
    toggleMobileFilter: function() {
      if (this.isMobile) {
        this.showMobileFilter = !this.showMobileFilter
      }
    },
    catsSet: function(catList) {
      for (var i = 0; i < catList.length; i++) {
        var cat = catList[i]
        var catArr = cat.ancestry.split('/')// '/110/113/156/' split yapınca [ "", "110", "113", "156", "" ] başta sonda boş array geliyor
        var catId = catArr[catArr.length - 2]// -2 ile boş arrayi almamış oluyoruz
        var catObj = catsFilter(nestedCats, 'id', catId)//cat idsinden objeyi elde ediyoruz
        if (catObj) {
          cat.name = catObj.name
          cat.id = catObj.id
          cat.path = catObj.path
          cat.priority = catObj.priority
        } else {//eğer ürün catObj bulunamıyorsa silinmiş olabilir, product.categories_ancestry de kalmış olabilir, filtrelerden siliyoruz
          arrObjRemove(catList, cat)
          i--//important js bugfix
        }
      }
    },
    setBrandFilter: function(brandId){
      brandId = brandId.toString()//params string geldiği için
      if (!this.filterData.brand_ids) this.filterData.brand_ids = []
      if (this.filterData.brand_ids.includes(brandId)) {
        this.filterData.brand_ids = arrRemove(this.filterData.brand_ids, brandId)
      } else {
        this.filterData.brand_ids.push(brandId)
      }
      if (this.filterData.brand_ids.length == 0) delete this.filterData.brand_ids
      this.submit()
    },
    setCatFilter: function(cat){
      if (this.brand) this.brand = null
      this.category = cat
      // this.toggleMobileFilter()
      this.submit()
    },
    setCodeFilter: function(colName, code_id){
      var codeID = code_id.toString()
      if (!this.filterData[colName]) this.filterData[colName] = []
      if (this.filterData[colName].includes(codeID)) {
        this.filterData[colName] = arrRemove(this.filterData[colName], codeID)
      } else {
        this.filterData[colName].push(codeID)
      }
      if (this.filterData[colName].length == 0) delete this.filterData[colName]
      this.submit()
    },
    setAttrFilter: function(attrId){
      attrId = attrId.toString()//params string geldiği için
      if (!this.filterData.attr_ids) this.filterData.attr_ids = []
      if (this.filterData.attr_ids.includes(attrId)) {
        this.filterData.attr_ids = arrRemove(this.filterData.attr_ids, attrId)
      } else {
        this.filterData.attr_ids.push(attrId)
      }
      if (this.filterData.attr_ids.length == 0) delete this.filterData.attr_ids
      this.submit()
    },
    setVariantFilter: function(variantId){
      variantId = variantId.toString()//params string geldiği için
      if (!this.filterData.variant_ids) this.filterData.variant_ids = []
      if (this.filterData.variant_ids.includes(variantId)) {
        this.filterData.variant_ids = arrRemove(this.filterData.variant_ids, variantId)
      } else {
        this.filterData.variant_ids.push(variantId)
      }
      if (this.filterData.variant_ids.length == 0) delete this.filterData.variant_ids
      this.submit()
    },
    setQueryFilter: function(){
      this.filterData.query = this.query
      this.submit()
    },
    setPriceRangeFilter: function(){
      this.submit()
    },
    setQueryDelayFilter: function(ms){
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      var _this = this
      this.timer = setTimeout(function () {
        _this.setQueryFilter()
      }, ms)
    },
    setOrderFilter: function(){
      this.submit()
    },
    setProdListPaymentPlan: function(){
      if(dbVar.reset_pay_plans){
        setGDataPaymentPlanId(localStorage.paymentPlanId)
      } else {
        setGDataPaymentPlanId(this.paymentPlanId)
      }
      this.submit()
    },
    submit: function() {
      spinning( this.isMobile ? $id('left-filter-body') : this.$el )
      var path = ''
      //sıralama yoksa ve ya varsayılan sıralama ile aynı ise ?order=XX çıkmaması için siliyoruz
      if (!this.filterData.order || this.filterData.order === dbVar[b2bc+'_default_order']) delete this.filterData.order
      delete this.filterData.page//sayfalamayı siliyoruz
      this.setOrderFilter
      if (!this.filterData.query) delete this.filterData.query//query boşsa aramadan kaldırıyoruz
      var apiData = jsonCopy(this.filterData)//api ye gönderilecek sorgu için obj klonlama
      apiData.all_object = true//paginate, filter, breadcrumb sonuçları dönsün diye
      if (this.category){
        path = this.category.path
        apiData.category_id = this.category.id
      } else if ( this.brand ) {
        path = this.brand.path
        apiData.brand_id = this.brand.id
        delete this.filterData.brand_ids
        delete apiData.brand_ids
      } else {//3ncü ihtimal search ten geliyordur
        path = searchPath()
      }
      if (this.paymentPlanId) apiData.payment_plan_id = this.paymentPlanId
      var queryStr = qs.stringify(this.filterData)
      path = path+(queryStr.length > 0 ? '?'+queryStr : '' )
      var apiQueryStr = qs.stringify(apiData)

      var _this = this
      securedAxiosInstance.get(apiProductsPath() + '?'+apiQueryStr)
        .then(function (response) {
        _this.products = jsonapi.parse(response.data.products).data
        _this.pagination = response.data.pagination
        _this.discUnits = response.data.discounted_units
        _this.codes = response.data.codes
        _this.breadcrumb = response.data.breadcrumb
        _this.brandList = response.data.filters.brands
        _this.catList = response.data.filters.sub_categories
        _this.codeList = response.data.filters.codes
        _this.attrList = response.data.filters.attrs
        _this.variantList = response.data.filters.variants
        _this._mounted()
        window.history.pushState({path: path}, null, path)
        spinningRemove()
      }).catch(function (error) {
        return console.log(error)
        spinningRemove()
      })

    },
    sortBrands: function(){
      if (this.brandListSortType == 'az'){
        this.brandList.sort(this.nameAscSortComparer)
        this.brandListSortType = 'za'
      } else if (this.brandListSortType == 'za') {
        this.brandList.sort(this.nameDescSortComparer)
        this.brandListSortType = 'count'
      } else if (this.brandListSortType == 'count') {
        this.brandList.sort(this.countSortComparer)
        this.brandListSortType = 'az'
      }
    },
    sortCodes: function(colName){
      var codeSortType = this.codesListSortType[colName]
      var code = this.codeList[colName]
      if (codeSortType === 'az'){
        code.sort(this.nameAscSortComparer)
        this.codesListSortType[colName] = 'za'
      } else if (codeSortType === 'za') {
        code.sort(this.nameDescSortComparer)
        this.codesListSortType[colName] = 'count'
      } else if (codeSortType === 'count') {
        code.sort(this.countSortComparer)
        this.codesListSortType[colName] = 'az'
      }
    },
    removeAllFilter: function(){
      this.filterData = {}
      this.submit()
    },
    setRemovaleFilter: function(){//page ve order parametreleri filtrelerin içine dahil olmuyor burada bunlar ayarlanıyor
      var filtersArr = Object.keys(this.filterData)
      if (this.filterData.order) filtersArr = arrRemove(filtersArr, 'order')
      if (this.filterData.page) filtersArr = arrRemove(filtersArr, 'page')
      filtersArr.length > 0 ? this.removableFilter = true : this.removableFilter = false
    },
    nameAscSortComparer: function(a,b){ return a.name.localeCompare(b.name, 'tr', {numeric: true, sensitive:'base'}) },
    nameDescSortComparer: function(a,b){ return b.name.localeCompare(a.name, 'tr', {numeric: true, sensitive:'base'}) },
    countSortComparer: function(a,b){ return b.count - a.count },
    categorySortComparer: function(a,b){ return a.priority - b.priority || a.name.localeCompare(b.name) },
    _mounted: function(){
      var _this = this
      this.brandList.map(function (b) { b.name = _this.brandName(b.id) })
      if ( this.brand ) this.filterData.brand_ids = [ this.brand.id.toString() ]//sayfa marka sayfasıysa
      this.catsSet(this.catList)
      this.catList.sort(this.categorySortComparer)
      e2Var.codeColNames.forEach(function(colName) {//tüm kodların default sıralaması count ta göre geliyor
        _this.codesListSortType[colName] = 'az'
      })
      this.setRemovaleFilter()
      if (!this.filterData.order) this.filterData = Object.assign({order: dbVar[b2bc+'_default_order']}, this.filterData)
    },
  },
  mounted: function() {
    if (dbVar.reset_pay_plans) {
      setGDataPaymentPlanId(localStorage.paymentPlanId)
    }
    var leftFilter = $(this.$el).find('.product-list-left-filter')
    if (this.isMobile) {
      leftFilter.hide()
      window.setTimeout(function () {
        leftFilter.fadeIn()
      }, 300)
    }
    if (this.category){
      this.category.path = window.location.pathname
    } else if ( this.brand ) {
      this.brand.path = window.location.pathname
    }
    this.query = this.filterData.query
    this._mounted()
  },
  watch: {
    showOnlyInStock: function(val){
      if (val == true) this.filterData.stock = 'true'
      else delete this.filterData.stock
      this.submit()
    }
  }
}


var orderCompleteMixin = {
  data: function data() {
    return {
      order_no: rData.order_no,
      order: rData.order,
      cart: rData.cart
    }
  },
  mounted: function () {
    setCartDetail(this.cart)
  }
}


var megaMenuMixin = {
  data: function data() {
    return {
      horizontalMenu: e2MegaMenus.filter(function (obj) { return obj._type === 'horizontal' })[0] || {},
      verticalMenu: e2MegaMenus.filter(function (obj) { return obj._type === 'vertical' })[0] || {},
      iconMenu: e2MegaMenus.filter(function (obj) { return obj._type === 'icon_menu' })[0] || {}
    }
  },
  methods: {
    getMenuItem: function(obj, col) {
      if (obj._type == 'category'){
        if (obj.all_categories) { return this.getItemProp(obj, col) }
        var category = catsFilter(nestedCats, 'id', obj.category_id)
        if (category) {
          if (col == 'name') {
            return category.name
          } else if (col == 'url') {
            return category.path
          }
        }
      } else if (obj._type == 'brand') {
        var brand = getObjFromObjs(brands, obj.brand_id)
        if (brand) {
          if (col == 'name') {
            return brand.name
          } else if (col == 'url') {
            return brand.path
          }
        }
      } else if (obj._type == 'custom' || obj._type == 'cols' || obj._type == 'link' || obj._type == 'html' || obj._type == 'category_images' || obj._type == 'brand_images'){
        return this.getItemProp(obj, col)
      } else {
        return '--'
      }
    },
    getItemProp: function(obj, col) {
      if (col == 'name') {
        return obj.title
      } else if (col == 'url') {
        return obj.url
      }
    },
    getCatChildren: function(category_id) {
      var cat = catsFilter(nestedCats, 'id', category_id);
      if (cat && cat.children.length > 0) {
        // Bu filtreleme işlemi menüde resimli kategori eklendikten sonra
        // eklenen kategorinin silinmesi, pasife alınması gibi durumlarda
        // "[null]" dönüp hata vermemesi için eklenmiştir.
        return cat.children.filter((child) => child !== null);
      } else {
        return cat !== null ? [cat] : [];
      }
    },
    getNestedCats: function(item) {
      if (item.all_categories){
        return nestedCats
      } else if (item.all_sub_categories) {
        var category = catsFilter(nestedCats, 'id', item.category_id)
        return category && category.children.length > 0 ? category.children : []
      }
    },
    mobileRowClass: function(item, col) {
      var subClass = (col._type === 'category_images' || col._type === 'brand_images') ? '' : 'sub' // sub class ı varsa soldan pedding veriliyor
      var collapseClass = this.getMenuItem(col, 'name') && item.cols.length > 1 ? 'collapse' : '' // menu_item ın başlığı varsa ve kolon sayısı 1 den büyükse kapalı(collapse) geliyor
      return subClass+' '+collapseClass
    },
  },
  mounted: function() {
    this.$nextTick(function () {
      //mobile click remove menu
      $(".mobile-menu a[href]").click(function() {
        if ($(this).attr('href') !== 'javascript:void(0)') {
          closeMobileMenu()
        }
      })
      //hack click remove menu
      $(".horizontal-menu a, .vertical-menu a").click(function() {
        if ($(this).attr('href') !== 'javascript:void(0)') {
          setTimeout(function () {
            $(".e2-mega-menu > ul > li").addClass('closed')
          }, 100)
          setTimeout(function () {
            $(".e2-mega-menu > ul > li").removeClass('closed')
          }, 200)
        }
      })

      $(".e2-mega-menu > ul > li.sub-menu").mouseenter(function() {
        var el = $(this).find('> ul')
        var parentUl = el.parent().parent()
        var mainDiv = $(this).parent().parent()
        var parentUlRo = parentUl.offset().left + parentUl.outerWidth()
        var elRo = el.offset().left + el.outerWidth()

        if (mainDiv.hasClass( "horizontal-menu" )) {
          //Genişlik parentten fazlaysa parent genişliğine limitleyelim
          if (el.outerWidth() > parentUl.outerWidth()) el.outerWidth( parentUl.outerWidth() )
          //parent in bitis pozisyonunu geçiyorsa sağa yaslayalım
          if (elRo > parentUlRo) el.css('right', 0)
        }
        if (mainDiv.hasClass( "vertical-menu" )) {
          //screen in bitis pozisyonunu geçiyorsa genişliği kısalım
          if (elRo > $(window).width()) el.outerWidth( el.outerWidth()-(elRo-$(window).width()+30) )

          // var mainTop = mainDiv.offset().top
          // var mainHeight = $(window).height()
          // var elTop = el.offset().top
          // var elementBottom = elTop + el.outerHeight()
          // console.log(elementBottom,mainTop,elTop,mainHeight)
        }
      })

      $('#icon-menu-slider').owlCarousel({
        margin: 10,
        dots: true,
        loop: true,
        responsive: {
        0: { items: 3 },
        768: { items: 4 },
        1200: { items: 6 }
        }
      })
    })

  }
}

var e2AlertMixin = {
  data: function() {
    return {
      alert: null,
      notice: null,
      exAlert: null,
      exNotice: null
    }
  },
  beforeUpdate: function() {
    if (this.exAlert && this.notice) this.alert = null
    if (this.exNotice && this.alert) this.notice = null
    if (this.alert) this.alert = this.alert+' ' // hack tekrar aynı hatayı verdiğinde update olsun ve scroll çalışsın
    if (this.notice) this.notice = this.notice+' ' // hack tekrar aynı hatayı verdiğinde update olsun ve scroll çalışsın
  },
  updated: function() {
    this.exAlert = this.alert
    this.exNotice = this.notice
    $('html, body').animate({
      scrollTop: $('#e2-alert').offset().top - 50
  }, 300);
  }
}

var subscriberMixin = {
  data: function data() {
    return {
      eposta: '',
      subStatus: Cookies.get("acceptSubscribe"),
    }
  },
  methods: {
    eSubs: function() {
      securedAxiosInstance.post(apiESubscribePath(), {eposta: this.eposta})
        .then(function (response) {
          if (response.data.code == '200') {
            ohSnap(response.data.message, {color: 'success', duration: "5000", icon: 'fa fa-user'})
            $("#subsForm input").val('').attr("placeholder", I18n.t('subscribe_success_msg'))
            $("#subsForm button, #subsForm input").prop("disabled", true)
            Cookies.set("acceptSubscribe", true, { expires: 3 })
          }
          else if (response.data.code == '400'){
            ohSnap(response.data.error_msg, {color: 'danger', duration: "5000", icon: 'fa fa-user'})
          }
        }).catch(function (error) {
          ohSnap("Error: " + error, {color: 'danger', duration: "5000", icon: 'fa fa-user'})
          console.log("Error:" + error)
      })
    },
  },
  mounted: function () {
   if (Cookies.get("acceptSubscribe")){
     $("#subsForm input").val('').attr("placeholder", I18n.t('subscribe_success_msg'))
     $("#subsForm button, #subsForm input").prop("disabled", true)
    }
  }
}

setGlobData();setDomain();setB2bc();

function redirectControl(ctx, next) {
  globalData.$data.isFpPage = (ctx.pathname === '/' || ctx.pathname === '/'+I18n.defaultLocale)
  if (ctx.params.lang === I18n.defaultLocale){// /tr/iletisim => /iletisim e çeviriliyor
    return page.redirect( (location.pathname+location.search).replace(/^.{3}/g, '') )
  }
  I18n.locale = (ctx.params.lang ? ctx.params.lang : I18n.defaultLocale);
  if (!e2Conf.available_langs.includes(I18n.locale)) {//eğer params lang lisanstaki dilleri içermiyorsa hata veriyoruz
    headful({ preStatus: '404' });
    alert('locale not found');
    return false
  }
  var rData = {};//burada kalmalı çok önemli
  setB2bc();//b2bc b2bcPath b2bg ayarlar
  // console.log(ctx.pathname);
  if (b2bc === 'b2b' && !b2bg && !ctx.pathname.startsWith(langPath() + 'contact') && !b2bSignedIn() && ctx.pathname !== (langPath() + 'b2b') && !ctx.pathname.startsWith(langPath() + 'b2b_user/') && ctx.type !== 'section' && !ctx.pathname.startsWith(langPath() + 'b2b/account/info')) {
    const redirect_path = langPath() + 'b2b'
    return page.redirect(redirect_path)//b2b logine redirect ediliyor
  } else if (b2bc === 'b2c' && ctx.pathname === '/b2b' && !b2bDomain) {
    return window.location.href = 'http://' + e2Conf.b2bDomain[0] + (location.port ? ':' + location.port : '')
  } else if (ctx.pathname === '/b2b' && !e2Conf.b2b) {
    return page.redirect('/')
  } else {
    // console.log(ctx.querystring)
  }
  next()
}
function sectionType(ctx, next){ctx.type = 'section'; next()}

page('/:lang([a-z]{2})?', redirectControl, loadScripts, fpLayout);
page('/:lang([a-z]{2})?/:name-p:id(\\d+)', redirectControl, loadScripts, productLayout);//ürün genel çerçeve blok
page('/:lang([a-z]{2})?/:name-c:id(\\d+)', redirectControl, loadScripts, categoryLayout);
page('/:lang([a-z]{2})?/:name-b:id(\\d+)', redirectControl, loadScripts, brandLayout);
page('/:lang([a-z]{2})?/:name-s:id(\\d+)', sectionType, redirectControl, loadScripts, sectionLayout);
page('/:lang([a-z]{2})?/:name-l:id(\\d+)', redirectControl, loadScripts, blogShowLayout);
page('/:lang([a-z]{2})?/search', redirectControl, loadScripts, searchLayout);
page('/:lang([a-z]{2})?/categories', redirectControl, loadScripts, categoryListLayout);
page('/:lang([a-z]{2})?/blog', redirectControl, loadScripts, blogListLayout);
page('/:lang([a-z]{2})?/promotions', redirectControl, loadScripts, promotionsLayout);
page('/:lang([a-z]{2})?/:name-r:id(\\d+)', redirectControl, loadScripts, promotionShowLayout);

//eski dia b2c route ları
page('/tr/:name-:id(\\d+).html', redirectControl, loadScripts, oldDiaProductLayout);
page('/tr/kategori/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);
page('/tr/kategori/:name/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);
page('/tr/kategori/:name/:name/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);
page('/tr/kategori/:name/:name/:name/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);
page('/tr/kategori/:name/:name/:name/:name/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);
page('/tr/kategori/:name/:name/:name/:name/:name/:name-:id(\\d+)', redirectControl, loadScripts, oldDiacategoryLayout);

// page('/:name-c:id(\\d+):bid(\\d+)?', redirectControl, setLangTr, loadScripts, categoryLayout);
// page('/:name-o:id(\\d+)', redirectControl, setLangTr, loadScripts, codeLayout);

page('/:lang([a-z]{2})?/b2c_user/:action(login|sign_up|activation|forgot_password|reset_password|checkout_guest)', redirectControl, loadScripts, b2cUserLayout);

// page('/:lang([a-z]{2})?/login', redirectControl, loadScripts, b2cLoginLayout);
// page('/:lang([a-z]{2})?/sign_up', redirectControl, loadScripts, b2cSignUpLayout);
page('/:lang([a-z]{2})?/logout', logoutPage);
page('/:lang([a-z]{2})?/contact', redirectControl, loadScripts, contactLayout);
page('/:lang([a-z]{2})?/cart', redirectControl, loadScripts, b2cCartLayout);
page('/:lang([a-z]{2})?/shopping/:action(address|payment|order_complete)', redirectControl, loadScripts, b2cShopLayout);
page('/:lang([a-z]{2})?/account/:action(info|orders|addresses|open_payment|open_payment_complete|favorites|order_return|order_return_form|repair_status_query)', redirectControl, loadScripts, myAccountLayout);

//################ B2B ###################
page('/:lang([a-z]{2})?/b2b', redirectControl, loadScripts, b2bLoginLayout);
page('/:lang([a-z]{2})?/b2b_user/:action(forgot_password|reset_password|salesperson_login)', redirectControl, loadScripts, b2bUserLayout);
page('/:lang([a-z]{2})?/b2b/cart', redirectControl, loadScripts, b2bCartLayout);
page('/:lang([a-z]{2})?/b2b/shopping/:action(address|payment|order_complete)', redirectControl, loadScripts, b2bShopLayout);
page('/:lang([a-z]{2})?/b2b/account/:action(info|addresses|open_payment|open_payment_complete|orders|dispatches|invoices|txns|service_forms|warranty_lookup|pending_orders_detail|favorites|order_return|order_return_form|repair_status_query|open_account_payment_list)', redirectControl, loadScripts, myAccountLayout);
page('/:lang([a-z]{2})?/b2b/reports/:action(hesap_ekstre|vade_analiz|ay_alis_satis)', redirectControl, loadScripts, b2bReportLayout);


// page('*', function(){ window.location = apiHost+apiLangPath()+apiVersion+'/404' })
page('*', function(){
  headful({ preStatus: '404' });
  page.redirect('/');
  alert('Sayfa Bulunamadı');
});

// page.exit((ctx, next) => { // sessionStorage a scroll kaydediyoruz
//   sessionStorage.setItem("scrollPosY_" + ctx.pathname, window.scrollY)
//   next()
// })


// function setLangTr(ctx, next){ I18n.locale = "tr"; next() }
// function setLangEn(ctx, next){ I18n.locale = "en"; next() }
var prevB2BC = ''; var prevLang = ''
function loadScripts(ctx, next){
  var globModelScript = globModelScriptPath()
  if (prevLang != I18n.locale || b2bc != prevB2BC) {
    securedAxiosInstance.get(globModelScript+randPrm)
    .then(function (response) {
      // console.log('global_models.js')
      prevLang = I18n.locale
      prevB2BC = b2bc
      eval(response.data)
      next()
    })
    .catch(function (e) {
      console.log(e)
    })
  } else {
    next()
  }
}

function fpLayout(ctx, next){ loadPageLayout(ctx, next, '/home.json') }
function productLayout(ctx, next){ loadPageLayout(ctx, next, '/products/'+ctx.params.id+'.json') }
function oldDiaProductLayout(ctx, next){ loadPageLayout(ctx, next, '/products/'+ctx.params.id+'/old_dia_show.json') }
function oldDiacategoryLayout(ctx, next){ loadPageLayout(ctx, next, '/categories/'+ctx.params.id+'/old_dia_show.json?'+ctx.querystring ) }

function categoryLayout(ctx, next){
  if (ctx.querystring.length > 0) {
    var queryHash = qs.parse(ctx.querystring)
    if (Object.keys(queryHash).length == 1 && queryHash.hasOwnProperty('page')) {
      loadPageLayout(ctx, next, '/categories/'+ctx.params.id+'/page/'+queryHash.page+'.json')
    } else {
      loadPageLayout(ctx, next, '/categories/'+ctx.params.id+'/query.json?'+ctx.querystring)
    }
  } else {
    loadPageLayout(ctx, next, '/categories/'+ctx.params.id+'.json')
  }
}
function brandLayout(ctx, next){
  if (ctx.querystring.length > 0) {
    var queryHash = qs.parse(ctx.querystring)
    if (Object.keys(queryHash).length == 1 && queryHash.hasOwnProperty('page')) {
      loadPageLayout(ctx, next, '/brands/'+ctx.params.id+'/page/'+queryHash.page+'.json')
    } else {
      loadPageLayout(ctx, next, '/brands/'+ctx.params.id+'/query.json?'+ctx.querystring)
    }
  } else {
    loadPageLayout(ctx, next, '/brands/'+ctx.params.id+'.json')
  }
}

function b2cUserLayout(ctx, next){ loadPageLayout(ctx, next, '/b2c_user/'+ctx.params.action+'.json?'+ctx.querystring) }
function b2cCartLayout(ctx, next){ loadPageLayout(ctx, next, '/carts.json') }
function b2cShopLayout(ctx, next){ loadPageLayout(ctx, next, '/shopping/'+ctx.params.action+'.json?'+ctx.querystring) }

//########## ORTAK ###############
function myAccountLayout(ctx, next){ loadPageLayout(ctx, next, '/account/'+ctx.params.action+'.json?'+ctx.querystring) }
function sectionLayout(ctx, next){ loadPageLayout(ctx, next, '/sections/'+ctx.params.id+'.json') }
function blogShowLayout(ctx, next){ loadPageLayout(ctx, next, '/blog/'+ctx.params.id+'.json') }
function searchLayout(ctx, next){ loadPageLayout(ctx, next, '/products/search.json?'+ctx.querystring) }
function categoryListLayout(ctx, next){ loadPageLayout(ctx, next, '/categories.json') }
function blogListLayout(ctx, next){ loadPageLayout(ctx, next, '/blog.json') }
function promotionsLayout(ctx, next){ loadPageLayout(ctx, next, '/promotions.json') }
function promotionShowLayout(ctx, next){ loadPageLayout(ctx, next, '/promotions/'+ctx.params.id+'.json') }
function contactLayout(ctx, next){ loadPageLayout(ctx, next, '/forms/contact.json') }

function b2bCartLayout(ctx, next){ loadPageLayout(ctx, next, '/carts.json') }
function b2bShopLayout(ctx, next){ loadPageLayout(ctx, next, '/shopping/'+ctx.params.action+'.json?'+ctx.querystring) }
function b2bReportLayout(ctx, next){ loadPageLayout(ctx, next, '/reports/'+ctx.params.action+'.json') }
function b2bLoginLayout(ctx, next){ loadPageLayout(ctx, next, '/b2b_user/login.json', 'b2b') }//alttakiyle aynı backend te aynı layout a gidiyor b2bc override ediliyor
function b2bUserLayout(ctx, next){ loadPageLayout(ctx, next, '/b2b_user/'+ctx.params.action+'.json?'+ctx.querystring, 'b2b') }


function logoutPage(ctx, next){
  securedAxiosInstance.delete(apiLogoutPath())
  .then(function (response) {
    delete localStorage.csrf;
    if (b2bc == 'b2b') {
      deleteB2bUserData();
    } else if (b2bc == 'b2c') {
      deleteB2cUserData();
    }
    e2Alert.notice = _('Çıkış başarılı');
    window.location.href = getLastRedirect();
    // setTimeout(function(){ window.location.href = getLastRedirect() }, 1000)
    // page.redirect(getLastRedirect())
  })
  .catch(function (e) {
    // if (e.response.status === 404) alert('404')
    console.log(e)
  })
}


